export default `:root {
    color-scheme: light dark;
    --_ui5-light-scheme: var(--_ui5-f2d95f8);
    --_ui5-dark-scheme:  ;
    --sapThemeMetaData-Base-baseLib: {"Path": "Base.baseLib.sap_horizon.css_variables","PathPattern": "/%frameworkId%/%libId%/%themeId%/%fileId%.css","Extends": ["baseTheme"],"Tags": ["Fiori_3","LightColorScheme"],"FallbackThemeId": "sap_fiori_3","Engine":{"Name": "theming-engine","Version": "17.0.3"},"Version":{"Build": "11.34.1.20260225145029","Source": "11.34.1"}};
    --sapBrandColor: #0070f2;
    --sapHighlightColor: light-dark(#0064d9, #4db1ff);
    --sapBaseColor: light-dark(#fff, #1d232a);
    --sapShellColor: light-dark(#fff, #1d232a);
    --sapBackgroundColor: light-dark(#f5f6f7, #12171c);
    --sapFontFamily: "72", "72full", Arial, Helvetica, sans-serif;
    --sapFontSize: .875rem;
    --sapTextColor: light-dark(#131e29, #f5f6f7);
    --sapLinkColor: light-dark(#0064d9, #008fff);
    --sapCompanyLogo: none;
    --sapFavicon: none;
    --sapBackgroundImage: none;
    --sapBackgroundImageOpacity: 1;
    --sapBackgroundImageRepeat: false;
    --sapSelectedColor: light-dark(#0064d9, #4db1ff);
    --sapHoverColor: light-dark(#eaecee, #222b35);
    --sapActiveColor: light-dark(#dee2e5, #020303);
    --sapTitleColor: light-dark(#131e29, #f5f6f7);
    --sapNegativeColor: light-dark(#aa0808, #fa6161);
    --sapCriticalColor: light-dark(#e76500, #ffdf72);
    --sapPositiveColor: light-dark(#256f3a, #97dd40);
    --sapInformativeColor: light-dark(#0070f2, #4db1ff);
    --sapNeutralColor: light-dark(#788fa6, #a9b4be);
    --sapNegativeElementColor: light-dark(#f53232, #fa6161);
    --sapCriticalElementColor: light-dark(#e76500, #f7bf00);
    --sapPositiveElementColor: light-dark(#30914c, #6dad1f);
    --sapInformativeElementColor: light-dark(#0070f2, #4db1ff);
    --sapNeutralElementColor: light-dark(#788fa6, #a9b4be);
    --sapNegativeTextColor: light-dark(#aa0808, #fa6161);
    --sapCriticalTextColor: light-dark(#b44f00, #ffdf72);
    --sapPositiveTextColor: light-dark(#256f3a, #97dd40);
    --sapInformativeTextColor: light-dark(#0064d9, #4db1ff);
    --sapNeutralTextColor: light-dark(#131e29, #f5f6f7);
    --sapErrorColor: light-dark(#aa0808, #fa6161);
    --sapWarningColor: light-dark(#e76500, #ffdf72);
    --sapSuccessColor: light-dark(#256f3a, #97dd40);
    --sapInformationColor: light-dark(#0070f2, #4db1ff);
    --sapErrorBackground: light-dark(#ffeaf4, #350000);
    --sapWarningBackground: light-dark(#fff8d6, #382700);
    --sapSuccessBackground: light-dark(#f5fae5, #11331a);
    --sapInformationBackground: light-dark(#e1f4ff, #00144a);
    --sapNeutralBackground: light-dark(#eff1f2, #242e38);
    --sapErrorBorderColor: light-dark(#e90b0b, #fa6161);
    --sapWarningBorderColor: light-dark(#dd6100, #f7bf00);
    --sapSuccessBorderColor: light-dark(#30914c, #6dad1f);
    --sapInformationBorderColor: light-dark(#0070f2, #4db1ff);
    --sapNeutralBorderColor: light-dark(#788fa6, #a9b4be);
    --sapElement_LineHeight: 2.75rem;
    --sapElement_Height: 2.25rem;
    --sapElement_BorderWidth: .0625rem;
    --sapElement_BorderCornerRadius: .75rem;
    --sapElement_Compact_LineHeight: 2rem;
    --sapElement_Compact_Height: 1.625rem;
    --sapElement_Condensed_LineHeight: 1.5rem;
    --sapElement_Condensed_Height: 1.375rem;
    --sapContent_LineHeight: 1.5;
    --sapContent_IconHeight: 1rem;
    --sapContent_IconColor: light-dark(#131e29, #f5f6f7);
    --sapContent_ContrastIconColor: light-dark(#fff, #1d232a);
    --sapContent_NonInteractiveIconColor: light-dark(#758ca4, #a9b4be);
    --sapContent_MarkerIconColor: light-dark(#5d36ff, #d3b6ff);
    --sapContent_MarkerTextColor: light-dark(#046c7a, #64edd2);
    --sapContent_MeasureIndicatorColor: light-dark(#556b81, #a9b4be);
    --sapContent_Selected_MeasureIndicatorColor: light-dark(#0064d9, #4db1ff);
    --sapContent_Placeholderloading_Background: light-dark(#ccc, #475566);
    --sapContent_Placeholderloading_Gradient: var(--_ui5-light-scheme, linear-gradient(to right, #ccc 0%, #ccc 20%, #999 50%, #ccc 80%, #ccc 100%)) var(--_ui5-dark-scheme, linear-gradient(to right, #475566 0%, #475566 20%, #74879f 50%, #475566 80%, #475566 100%));
    --sapContent_ImagePlaceholderBackground: light-dark(#eaecee, #45617c);
    --sapContent_ImagePlaceholderForegroundColor: light-dark(#556b82, #d5dadd);
    --sapContent_RatedColor: light-dark(#d27700, #ffdf72);
    --sapContent_UnratedColor: light-dark(#758ca4, #a9b4be);
    --sapContent_BusyColor: light-dark(#0064d9, #4db1ff);
    --sapContent_FocusColor: light-dark(#0032a5, #9ad3ff);
    --sapContent_FocusStyle: solid;
    --sapContent_FocusWidth: .125rem;
    --sapContent_ContrastFocusColor: light-dark(#fff, #000);
    --sapContent_ShadowColor: light-dark(#223548, #000);
    --sapContent_ContrastShadowColor: #fff;
    --sapContent_Shadow0: var(--_ui5-light-scheme, 0 0 .125rem 0 rgba(34,53,72,.2), 0 .125rem .25rem 0 rgba(34,53,72,.2)) var(--_ui5-dark-scheme, 0 0 .125rem 0 rgba(255,255,255,.6), 0 .125rem .5rem 0 rgba(0,0,0,.2));
    --sapContent_Shadow1: var(--_ui5-light-scheme, 0 0 0 .0625rem rgba(34,53,72,.48), 0 .125rem .5rem 0 rgba(34,53,72,.3)) var(--_ui5-dark-scheme, 0 0 0 .0625rem rgba(255,255,255,.35), 0 .125rem .5rem 0 rgba(0,0,0,.6));
    --sapContent_Shadow2: var(--_ui5-light-scheme, 0 0 0 .0625rem rgba(34,53,72,.48), 0 .625rem 1.875rem 0 rgba(34,53,72,.25)) var(--_ui5-dark-scheme, 0 0 0 .0625rem rgba(255,255,255,.35), 0 .625rem 1.875rem 0 rgba(0,0,0,.6));
    --sapContent_Shadow3: var(--_ui5-light-scheme, 0 0 0 .0625rem rgba(34,53,72,.48), 0 1.25rem 5rem 0 rgba(34,53,72,.25)) var(--_ui5-dark-scheme, 0 0 0 .0625rem rgba(255,255,255,.35), 0 1.25rem 5rem 0 rgba(0,0,0,.6));
    --sapContent_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #fff) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapContent_ContrastTextShadow: var(--_ui5-light-scheme, 0 0 .0625rem rgba(0,0,0,.7)) var(--_ui5-dark-scheme, none);
    --sapContent_HeaderShadow: var(--_ui5-light-scheme, 0 .125rem .125rem 0 rgba(34,53,72,.05), inset 0 -.0625rem 0 0 #d9d9d9) var(--_ui5-dark-scheme, 0 .125rem .125rem 0 rgba(0,0,0,.2), inset 0 -.0625rem 0 0 #2e3742);
    --sapContent_Interaction_Shadow: var(--_ui5-light-scheme, inset 0 0 0 .0625rem rgba(85,107,129,.25)) var(--_ui5-dark-scheme, inset 0 0 0 .0625rem rgba(169,180,190,.25));
    --sapContent_Selected_Shadow: var(--_ui5-light-scheme, inset 0 0 0 .0625rem rgba(79,160,255,.5)) var(--_ui5-dark-scheme, inset 0 0 0 .0625rem rgba(77,177,255,.3));
    --sapContent_Negative_Shadow: var(--_ui5-light-scheme, inset 0 0 0 .0625rem rgba(255,142,196,.45)) var(--_ui5-dark-scheme, inset 0 0 0 .0625rem rgba(248,38,38,.3));
    --sapContent_Critical_Shadow: var(--_ui5-light-scheme, inset 0 0 0 .0625rem rgba(255,213,10,.4)) var(--_ui5-dark-scheme, inset 0 0 0 .0625rem rgba(132,92,0,.5));
    --sapContent_Positive_Shadow: var(--_ui5-light-scheme, inset 0 0 0 .0625rem rgba(48,145,76,.18)) var(--_ui5-dark-scheme, inset 0 0 0 .0625rem rgba(109,173,31,.18));
    --sapContent_Informative_Shadow: var(--_ui5-light-scheme, inset 0 0 0 .0625rem rgba(104,174,255,.5)) var(--_ui5-dark-scheme, inset 0 0 0 .0625rem rgba(77,177,255,.3));
    --sapContent_Neutral_Shadow: var(--_ui5-light-scheme, inset 0 0 0 .0625rem rgba(120,143,166,.3)) var(--_ui5-dark-scheme, inset 0 0 0 .0625rem rgba(169,180,190,.3));
    --sapContent_SearchHighlightColor: light-dark(#dafdf5, #046c7a);
    --sapContent_HelpColor: light-dark(#188918, #5dc122);
    --sapContent_LabelColor: light-dark(#556b82, #8396A8);
    --sapContent_MonospaceFontFamily: "72Mono", "72Monofull", lucida console, monospace;
    --sapContent_MonospaceBoldFontFamily: "72Mono-Bold", "72Mono-Boldfull", lucida console, monospace;
    --sapContent_IconFontFamily: "SAP-icons";
    --sapContent_DisabledTextColor: light-dark(rgba(19,30,41,.6), rgba(245,246,247,.6));
    --sapContent_DisabledOpacity: .4;
    --sapContent_ContrastTextThreshold: var(--_ui5-light-scheme, .65) var(--_ui5-dark-scheme, .386);
    --sapContent_ContrastTextColor: light-dark(#fff, #1d232a);
    --sapContent_ForegroundColor: light-dark(#efefef, #101418);
    --sapContent_ForegroundBorderColor: light-dark(#758ca4, #a9b4be);
    --sapContent_ForegroundTextColor: light-dark(#131e29, #f5f6f7);
    --sapContent_BadgeBackground: light-dark(#aa0808, #ff8cb2);
    --sapContent_BadgeTextColor: light-dark(#fff, #1d232a);
    --sapContent_BadgeBorderColor: light-dark(#fff, #1d232a);
    --sapContent_DragAndDropActiveColor: light-dark(#0064d9, #4db1ff);
    --sapContent_Selected_TextColor: light-dark(#0064d9, #4db1ff);
    --sapContent_Selected_Background: light-dark(#fff, #1d232a);
    --sapContent_Selected_Hover_Background: light-dark(#e3f0ff, #002b4d);
    --sapContent_Selected_ForegroundColor: light-dark(#0064d9, #4db1ff);
    --sapContent_ForcedColorAdjust: none;
    --sapContent_Lite_Shadow: none;
    --sapContent_Illustrative_Color1: #9b015d;
    --sapContent_Illustrative_Color2: light-dark(#56bdff, #4d82b8);
    --sapContent_Illustrative_Color3: #ff7f4c;
    --sapContent_Illustrative_Color4: light-dark(#00144a, #688fb7);
    --sapContent_Illustrative_Color5: light-dark(#a9b4be, #fff);
    --sapContent_Illustrative_Color6: light-dark(#d5dadd, #818f98);
    --sapContent_Illustrative_Color7: light-dark(#dbf1ff, #101619);
    --sapContent_Illustrative_Color8: light-dark(#fff, #d5dadd);
    --sapContent_Illustrative_Color9: #0899a7;
    --sapContent_Illustrative_Color10: light-dark(#dbf1ff, #ebf8ff);
    --sapContent_Illustrative_Color11: light-dark(#df1278, #fa4f96);
    --sapContent_Illustrative_Color12: #00a800;
    --sapContent_Illustrative_Color13: light-dark(#0070f2, #3b5b7c);
    --sapContent_Illustrative_Color14: light-dark(#0040b0, #2a4259);
    --sapContent_Illustrative_Color15: #c35500;
    --sapContent_Illustrative_Color16: #8d2a00;
    --sapContent_Illustrative_Color17: #046c7c;
    --sapContent_Illustrative_Color18: light-dark(#bce5ff, #2a4259);
    --sapContent_Illustrative_Color19: light-dark(#a3dbff, #324e6b);
    --sapContent_Illustrative_Color20: light-dark(#89d1ff, #222f3b);
    --sapContent_Illustrative_Color21: light-dark(#1b90ff, #101619);
    --sapContent_Illustrative_Color22: #00144a;
    --sapContent_Illustrative_Color23: #d20a0a;
    --sapContent_Illustrative_Color24: light-dark(#ffb2d2, #d094b0);
    --sapContent_Illustrative_Color25: light-dark(#ffeaf4, #d0c1cb);
    --sapContent_Illustrative_Color26: light-dark(#ffdf72, #d0b863);
    --sapContent_Illustrative_Color27: light-dark(#fff8d6, #d0cdb3);
    --sapContent_Illustrative_Color28: #a93e00;
    --sapContent_Illustrative_Color29: #450b00;
    --sapContent_Illustrative_Color30: #340800;
    --sapContent_Illustrative_Color31: #ffab92;
    --sapContent_Space_S: 1rem;
    --sapContent_Space_M: 2rem;
    --sapContent_Space_L: 2rem;
    --sapContent_Space_XL: 3rem;
    --sapContent_Space_Tiny: .5rem;
    --sapContent_Space_Small: 1rem;
    --sapContent_Space_Medium: 2rem;
    --sapContent_Space_Large: 3rem;
    --sapContent_Margin_Tiny: 0 0 1rem;
    --sapContent_Margin_Small: 1rem;
    --sapContent_Margin_Medium: 1rem 2rem;
    --sapContent_Margin_Large: 1rem 3rem;
    --sapContent_Margin_S: 0 0 1rem;
    --sapContent_Margin_M: 1rem;
    --sapContent_Margin_L: 1rem 2rem;
    --sapContent_Margin_XL: 1rem 3rem;
    --sapContent_Padding_S: 0rem;
    --sapContent_Padding_M: 2rem;
    --sapContent_Padding_L: 2rem;
    --sapContent_Padding_XL: 3rem;
    --sapContent_Gap: 1rem;
    --sapContent_Success_HeaderShadow: var(--_ui5-light-scheme, 0 .125rem .125rem 0 rgba(34,53,72,.05), inset 0 -.0625rem 0 0 #30914c) var(--_ui5-dark-scheme, 0 .125rem .125rem 0 rgba(0,0,0,.2), inset 0 -.0625rem 0 0 #6dad1f);
    --sapContent_Warning_HeaderShadow: var(--_ui5-light-scheme, 0 .125rem .125rem 0 rgba(34,53,72,.05), inset 0 -.0625rem 0 0 #dd6100) var(--_ui5-dark-scheme, 0 .125rem .125rem 0 rgba(0,0,0,.2), inset 0 -.0625rem 0 0 #f7bf00);
    --sapContent_Error_HeaderShadow: var(--_ui5-light-scheme, 0 .125rem .125rem 0 rgba(34,53,72,.05), inset 0 -.0625rem 0 0 #e90b0b) var(--_ui5-dark-scheme, 0 .125rem .125rem 0 rgba(0,0,0,.2), inset 0 -.0625rem 0 0 #fa6161);
    --sapContent_Information_HeaderShadow: var(--_ui5-light-scheme, 0 .125rem .125rem 0 rgba(34,53,72,.05), inset 0 -.0625rem 0 0 #0070f2) var(--_ui5-dark-scheme, 0 .125rem .125rem 0 rgba(0,0,0,.2), inset 0 -.0625rem 0 0 #4db1ff);
    --sapFontLightFamily: "72-Light", "72-Lightfull", "72", "72full", Arial, Helvetica, sans-serif;
    --sapFontBoldFamily: "72-Bold", "72-Boldfull", "72", "72full", Arial, Helvetica, sans-serif;
    --sapFontSemiboldFamily: "72-Semibold", "72-Semiboldfull", "72", "72full", Arial, Helvetica, sans-serif;
    --sapFontSemiboldDuplexFamily: "72-SemiboldDuplex", "72-SemiboldDuplexfull", "72", "72full", Arial, Helvetica, sans-serif;
    --sapFontBlackFamily: "72Black", "72Blackfull","72", "72full", Arial, Helvetica, sans-serif;
    --sapFontHeaderFamily: "72-Bold", "72-Boldfull", "72", "72full", Arial, Helvetica, sans-serif;
    --sapFontSmallSize: .75rem;
    --sapFontLargeSize: 1rem;
    --sapFontHeader1Size: 3rem;
    --sapFontHeader2Size: 2rem;
    --sapFontHeader3Size: 1.5rem;
    --sapFontHeader4Size: 1.25rem;
    --sapFontHeader5Size: 1rem;
    --sapFontHeader6Size: .875rem;
    --sapLink_TextDecoration: none;
    --sapLink_Hover_Color: light-dark(#0064d9, #008fff);
    --sapLink_Hover_TextDecoration: underline;
    --sapLink_Active_Color: light-dark(#0064d9, #008fff);
    --sapLink_Active_TextDecoration: none;
    --sapLink_Visited_Color: light-dark(#0064d9, #008fff);
    --sapLink_InvertedColor: light-dark(#a6cfff, #bde2ff);
    --sapLink_SubtleColor: light-dark(#131e29, #f5f6f7);
    --sapShell_Background: light-dark(#eff1f2, #12171c);
    --sapShell_BackgroundImage: var(--_ui5-light-scheme, linear-gradient(to bottom, #eff1f2, #eff1f2)) var(--_ui5-dark-scheme, linear-gradient(to bottom, #12171c, #12171c));
    --sapShell_BackgroundImageOpacity: 1;
    --sapShell_BackgroundImageRepeat: false;
    --sapShell_BorderColor: light-dark(#d9d9d9, #2e3742);
    --sapShell_TextColor: light-dark(#131e29, #f5f6f7);
    --sapShell_InteractiveBackground: light-dark(#eff1f2, #12171c);
    --sapShell_InteractiveTextColor: light-dark(#131e29, #f5f6f7);
    --sapShell_InteractiveBorderColor: light-dark(#556b81, #a9b4be);
    --sapShell_GroupTitleTextColor: light-dark(#131e29, #f5f6f7);
    --sapShell_GroupTitleTextShadow: var(--_ui5-light-scheme, 0 0 .125rem #fff) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapShell_Hover_Background: light-dark(#fff, #1d232a);
    --sapShell_Active_Background: light-dark(#fff, #1d232a);
    --sapShell_Active_TextColor: light-dark(#0070f2, #4db1ff);
    --sapShell_Selected_Background: light-dark(#fff, #1d232a);
    --sapShell_Selected_TextColor: light-dark(#0070f2, #4db1ff);
    --sapShell_Selected_Hover_Background: light-dark(#fff, #1d232a);
    --sapShell_Favicon: none;
    --sapShell_Navigation_Background: light-dark(#fff, #1d232a);
    --sapShell_Navigation_Hover_Background: light-dark(#fff, #1d232a);
    --sapShell_Navigation_SelectedColor: light-dark(#0064d9, #4db1ff);
    --sapShell_Navigation_Selected_TextColor: light-dark(#0064d9, #4db1ff);
    --sapShell_Navigation_TextColor: light-dark(#131e29, #f5f6f7);
    --sapShell_Navigation_Active_TextColor: light-dark(#0064d9, #4db1ff);
    --sapShell_Navigation_Active_Background: light-dark(#fff, #1d232a);
    --sapShell_Shadow: var(--_ui5-light-scheme, 0 .125rem .125rem 0 rgba(34,53,72,.15), inset 0 -.0625rem 0 0 rgba(34,53,72,.2)) var(--_ui5-dark-scheme, 0 .125rem .125rem 0 rgba(0,0,0,.8), inset 0 -.0625rem 0 0 rgba(255,255,255,.2));
    --sapShell_NegativeColor: light-dark(#aa0808, #fa6161);
    --sapShell_CriticalColor: light-dark(#b44f00, #ffdf72);
    --sapShell_PositiveColor: light-dark(#256f3a, #97dd40);
    --sapShell_InformativeColor: light-dark(#0064d9, #4db1ff);
    --sapShell_NeutralColor: light-dark(#131e29, #f5f6f7);
    --sapShell_Assistant_ForegroundColor: light-dark(#5d36ff, #8e73ff);
    --sapShell_SubBrand_TextColor: light-dark(#003e87, #a5cfff);
    --sapShell_Category_1_Background: light-dark(#0057d2, #89d1ff);
    --sapShell_Category_1_BorderColor: light-dark(#0057d2, #89d1ff);
    --sapShell_Category_1_TextColor: light-dark(#fff, #1d232a);
    --sapShell_Category_1_TextShadow: var(--_ui5-light-scheme, 0 0 .0625rem rgba(0,0,0,.7)) var(--_ui5-dark-scheme, none);
    --sapShell_Category_2_Background: light-dark(#df1278, #feadc8);
    --sapShell_Category_2_BorderColor: light-dark(#df1278, #feadc8);
    --sapShell_Category_2_TextColor: light-dark(#fff, #1d232a);
    --sapShell_Category_2_TextShadow: var(--_ui5-light-scheme, 0 0 .0625rem rgba(0,0,0,.7)) var(--_ui5-dark-scheme, none);
    --sapShell_Category_3_Background: light-dark(#e76500, #ffb300);
    --sapShell_Category_3_BorderColor: light-dark(#e76500, #ffb300);
    --sapShell_Category_3_TextColor: light-dark(#fff, #1d232a);
    --sapShell_Category_3_TextShadow: var(--_ui5-light-scheme, 0 0 .0625rem rgba(0,0,0,.7)) var(--_ui5-dark-scheme, none);
    --sapShell_Category_4_Background: light-dark(#7800a4, #aa7dd9);
    --sapShell_Category_4_BorderColor: light-dark(#7800a4, #aa7dd9);
    --sapShell_Category_4_TextColor: light-dark(#fff, #1d232a);
    --sapShell_Category_4_TextShadow: var(--_ui5-light-scheme, 0 0 .0625rem rgba(0,0,0,.7)) var(--_ui5-dark-scheme, none);
    --sapShell_Category_5_Background: light-dark(#aa2608, #fbbfac);
    --sapShell_Category_5_BorderColor: light-dark(#aa2608, #fbbfac);
    --sapShell_Category_5_TextColor: light-dark(#fff, #1d232a);
    --sapShell_Category_5_TextShadow: var(--_ui5-light-scheme, 0 0 .0625rem rgba(0,0,0,.7)) var(--_ui5-dark-scheme, none);
    --sapShell_Category_6_Background: light-dark(#07838f, #2ce0bf);
    --sapShell_Category_6_BorderColor: light-dark(#07838f, #2ce0bf);
    --sapShell_Category_6_TextColor: light-dark(#fff, #1d232a);
    --sapShell_Category_6_TextShadow: var(--_ui5-light-scheme, 0 0 .0625rem rgba(0,0,0,.7)) var(--_ui5-dark-scheme, none);
    --sapShell_Category_7_Background: light-dark(#f31ded, #ff8af0);
    --sapShell_Category_7_BorderColor: light-dark(#f31ded, #ff8af0);
    --sapShell_Category_7_TextColor: light-dark(#fff, #1d232a);
    --sapShell_Category_7_TextShadow: var(--_ui5-light-scheme, 0 0 .0625rem rgba(0,0,0,.7)) var(--_ui5-dark-scheme, none);
    --sapShell_Category_8_Background: light-dark(#188918, #97dd40);
    --sapShell_Category_8_BorderColor: light-dark(#188918, #97dd40);
    --sapShell_Category_8_TextColor: light-dark(#fff, #1d232a);
    --sapShell_Category_8_TextShadow: var(--_ui5-light-scheme, 0 0 .0625rem rgba(0,0,0,.7)) var(--_ui5-dark-scheme, none);
    --sapShell_Category_9_Background: light-dark(#002a86, #1b90ff);
    --sapShell_Category_9_BorderColor: light-dark(#002a86, #1b90ff);
    --sapShell_Category_9_TextColor: light-dark(#fff, #1d232a);
    --sapShell_Category_9_TextShadow: var(--_ui5-light-scheme, 0 0 .0625rem rgba(0,0,0,.7)) var(--_ui5-dark-scheme, none);
    --sapShell_Category_10_Background: light-dark(#5b738b, #8396a8);
    --sapShell_Category_10_BorderColor: light-dark(#5b738b, #8396a8);
    --sapShell_Category_10_TextColor: light-dark(#fff, #1d232a);
    --sapShell_Category_10_TextShadow: var(--_ui5-light-scheme, 0 0 .0625rem rgba(0,0,0,.7)) var(--_ui5-dark-scheme, none);
    --sapShell_Category_11_Background: light-dark(#d20a0a, #fe5656);
    --sapShell_Category_11_BorderColor: light-dark(#d20a0a, #fe5656);
    --sapShell_Category_11_TextColor: light-dark(#fff, #1d232a);
    --sapShell_Category_11_TextShadow: var(--_ui5-light-scheme, 0 0 .0625rem rgba(0,0,0,.7)) var(--_ui5-dark-scheme, none);
    --sapShell_Category_12_Background: light-dark(#7858ff, #9b99ff);
    --sapShell_Category_12_BorderColor: light-dark(#7858ff, #9b99ff);
    --sapShell_Category_12_TextColor: light-dark(#fff, #1d232a);
    --sapShell_Category_12_TextShadow: var(--_ui5-light-scheme, 0 0 .0625rem rgba(0,0,0,.7)) var(--_ui5-dark-scheme, none);
    --sapShell_Category_13_Background: light-dark(#a00875, #f52ebc);
    --sapShell_Category_13_BorderColor: light-dark(#a00875, #f52ebc);
    --sapShell_Category_13_TextColor: light-dark(#fff, #1d232a);
    --sapShell_Category_13_TextShadow: var(--_ui5-light-scheme, 0 0 .0625rem rgba(0,0,0,.7)) var(--_ui5-dark-scheme, none);
    --sapShell_Category_14_Background: light-dark(#14565b, #0ba38a);
    --sapShell_Category_14_BorderColor: light-dark(#14565b, #0ba38a);
    --sapShell_Category_14_TextColor: light-dark(#fff, #1d232a);
    --sapShell_Category_14_TextShadow: var(--_ui5-light-scheme, 0 0 .0625rem rgba(0,0,0,.7)) var(--_ui5-dark-scheme, none);
    --sapShell_Category_15_Background: light-dark(#223548, #d5dadd);
    --sapShell_Category_15_BorderColor: light-dark(#223548, #d5dadd);
    --sapShell_Category_15_TextColor: light-dark(#fff, #1d232a);
    --sapShell_Category_15_TextShadow: var(--_ui5-light-scheme, 0 0 .0625rem rgba(0,0,0,.7)) var(--_ui5-dark-scheme, none);
    --sapShell_Category_16_Background: light-dark(#1e592f, #39ad1f);
    --sapShell_Category_16_BorderColor: light-dark(#1e592f, #39ad1f);
    --sapShell_Category_16_TextColor: light-dark(#fff, #1d232a);
    --sapShell_Category_16_TextShadow: var(--_ui5-light-scheme, 0 0 .0625rem rgba(0,0,0,.7)) var(--_ui5-dark-scheme, none);
    --sapShell_Space_S: .5rem;
    --sapShell_Space_M: 2rem;
    --sapShell_Space_L: 2rem;
    --sapShell_Space_XL: 3rem;
    --sapShell_Gap_S: .5rem;
    --sapShell_Gap_M: 1rem;
    --sapShell_Gap_L: 1rem;
    --sapShell_Gap_XL: 1rem;
    --sapShell_GroupGap_S: 2rem;
    --sapShell_GroupGap_M: 3rem;
    --sapShell_GroupGap_L: 3rem;
    --sapShell_GroupGap_XL: 3rem;
    --sapAssistant_Color1: #5d36ff;
    --sapAssistant_Color2: #a100c2;
    --sapAssistant_BackgroundGradient: linear-gradient(#5d36ff, #a100c2);
    --sapAssistant_Background: #5d36ff;
    --sapAssistant_BorderColor: #5d36ff;
    --sapAssistant_TextColor: #fff;
    --sapAssistant_Hover_Background: #2800cf;
    --sapAssistant_Hover_BorderColor: #2800cf;
    --sapAssistant_Hover_TextColor: #fff;
    --sapAssistant_Active_Background: light-dark(#fff, #140069);
    --sapAssistant_Active_BorderColor: light-dark(#5d36ff, #c0b0ff);
    --sapAssistant_Active_TextColor: light-dark(#5d36ff, #c0b0ff);
    --sapAssistant_Question_Background: light-dark(#eae5ff, #140066);
    --sapAssistant_Question_BorderColor: light-dark(#eae5ff, #140066);
    --sapAssistant_Question_TextColor: light-dark(#131e29, #f5f6f7);
    --sapAssistant_Answer_Background: light-dark(#eff1f2, #12171c);
    --sapAssistant_Answer_BorderColor: light-dark(#eff1f2, #12171c);
    --sapAssistant_Answer_TextColor: light-dark(#131e29, #f5f6f7);
    --sapAvatar_1_Background: light-dark(#fff3b8, #ae4000);
    --sapAvatar_1_BorderColor: light-dark(#fff3b8, #ae4000);
    --sapAvatar_1_TextColor: light-dark(#a45d00, #ffdf72);
    --sapAvatar_1_Hover_Background: light-dark(#fff3b8, #ae4000);
    --sapAvatar_2_Background: light-dark(#ffd0e7, #890506);
    --sapAvatar_2_BorderColor: light-dark(#ffd0e7, #890506);
    --sapAvatar_2_TextColor: light-dark(#aa0808, #ff8cb2);
    --sapAvatar_2_Hover_Background: light-dark(#ffd0e7, #890506);
    --sapAvatar_3_Background: light-dark(#ffdbe7, #b40569);
    --sapAvatar_3_BorderColor: light-dark(#ffdbe7, #b40569);
    --sapAvatar_3_TextColor: light-dark(#ba066c, #fecbda);
    --sapAvatar_3_Hover_Background: light-dark(#ffdbe7, #b40569);
    --sapAvatar_4_Background: light-dark(#ffdcf3, #8700b8);
    --sapAvatar_4_BorderColor: light-dark(#ffdcf3, #8700b8);
    --sapAvatar_4_TextColor: light-dark(#a100c2, #ffafed);
    --sapAvatar_4_Hover_Background: light-dark(#ffdcf3, #8700b8);
    --sapAvatar_5_Background: light-dark(#ded3ff, #470cf1);
    --sapAvatar_5_BorderColor: light-dark(#ded3ff, #470cf1);
    --sapAvatar_5_TextColor: light-dark(#552cff, #d3b6ff);
    --sapAvatar_5_Hover_Background: light-dark(#ded3ff, #470cf1);
    --sapAvatar_6_Background: light-dark(#d1efff, #0054cc);
    --sapAvatar_6_BorderColor: light-dark(#d1efff, #0054cc);
    --sapAvatar_6_TextColor: light-dark(#0057d2, #a6e0ff);
    --sapAvatar_6_Hover_Background: light-dark(#d1efff, #0054cc);
    --sapAvatar_7_Background: light-dark(#c2fcee, #036573);
    --sapAvatar_7_BorderColor: light-dark(#c2fcee, #036573);
    --sapAvatar_7_TextColor: light-dark(#046c7a, #64edd2);
    --sapAvatar_7_Hover_Background: light-dark(#c2fcee, #036573);
    --sapAvatar_8_Background: light-dark(#ebf5cb, #236c39);
    --sapAvatar_8_BorderColor: light-dark(#ebf5cb, #236c39);
    --sapAvatar_8_TextColor: light-dark(#256f3a, #bde986);
    --sapAvatar_8_Hover_Background: light-dark(#ebf5cb, #236c39);
    --sapAvatar_9_Background: light-dark(#ddccf0, #4e247a);
    --sapAvatar_9_BorderColor: light-dark(#ddccf0, #4e247a);
    --sapAvatar_9_TextColor: light-dark(#6c32a9, #b995e0);
    --sapAvatar_9_Hover_Background: light-dark(#ddccf0, #4e247a);
    --sapAvatar_10_Background: light-dark(#eaecee, #45617c);
    --sapAvatar_10_BorderColor: light-dark(#eaecee, #45617c);
    --sapAvatar_10_TextColor: light-dark(#556b82, #d5dadd);
    --sapAvatar_10_Hover_Background: light-dark(#eaecee, #45617c);
    --sapAvatar_Lite_BorderColor: transparent;
    --sapAvatar_Lite_Background: transparent;
    --sapAvatar_Hover_BorderColor: light-dark(rgba(85,107,129,.25), rgba(169,180,190,.25));
    --sapButton_Background: light-dark(#fff, #1c242c);
    --sapButton_BorderColor: light-dark(#bcc3ca, #3a4a5a);
    --sapButton_BorderWidth: .0625rem;
    --sapButton_BorderCornerRadius: .5rem;
    --sapButton_TextColor: light-dark(#0064d9, #4db1ff);
    --sapButton_FontFamily: "72-SemiboldDuplex", "72-SemiboldDuplexfull", "72", "72full", Arial, Helvetica, sans-serif;
    --sapButton_Hover_Background: light-dark(#eaecee, #222b35);
    --sapButton_Hover_BorderColor: light-dark(#bcc3ca, #3a4a5a);
    --sapButton_Hover_TextColor: light-dark(#0064d9, #4db1ff);
    --sapButton_IconColor: light-dark(#0064d9, #4db1ff);
    --sapButton_Active_Background: light-dark(#fff, #213131);
    --sapButton_Active_BorderColor: light-dark(#0064d9, #4db1ff);
    --sapButton_Active_TextColor: light-dark(#0064d9, #4db1ff);
    --sapButton_Emphasized_Background: #0070f2;
    --sapButton_Emphasized_BorderColor: #0070f2;
    --sapButton_Emphasized_BorderWidth: .0625rem;
    --sapButton_Emphasized_TextColor: #fff;
    --sapButton_Emphasized_FontFamily: "72-Bold", "72-Boldfull", "72", "72full", Arial, Helvetica, sans-serif;
    --sapButton_Emphasized_Hover_Background: #0064d9;
    --sapButton_Emphasized_Hover_BorderColor: #0064d9;
    --sapButton_Emphasized_Hover_TextColor: light-dark(#fff, #f5f6f7);
    --sapButton_Emphasized_Active_Background: light-dark(#fff, #213131);
    --sapButton_Emphasized_Active_BorderColor: light-dark(#0064d9, #4db1ff);
    --sapButton_Emphasized_Active_TextColor: light-dark(#0064d9, #4db1ff);
    --sapButton_Emphasized_TextShadow: transparent;
    --sapButton_Reject_Background: light-dark(#ffd6e9, #490000);
    --sapButton_Reject_BorderColor: light-dark(#ffc2de, #620000);
    --sapButton_Reject_TextColor: light-dark(#aa0808, #fa6161);
    --sapButton_Reject_Hover_Background: light-dark(#ffbddb, #620000);
    --sapButton_Reject_Hover_BorderColor: light-dark(#ffbddb, #620000);
    --sapButton_Reject_Hover_TextColor: light-dark(#aa0808, #fa6161);
    --sapButton_Reject_Active_Background: light-dark(#fff, #213131);
    --sapButton_Reject_Active_BorderColor: light-dark(#e90b0b, #fa6161);
    --sapButton_Reject_Active_TextColor: light-dark(#aa0808, #fa6161);
    --sapButton_Reject_Selected_Background: light-dark(#fff, #213131);
    --sapButton_Reject_Selected_BorderColor: light-dark(#e90b0b, #fa6161);
    --sapButton_Reject_Selected_TextColor: light-dark(#aa0808, #fa6161);
    --sapButton_Reject_Selected_Hover_Background: light-dark(#ffbddb, #620000);
    --sapButton_Reject_Selected_Hover_BorderColor: light-dark(#e90b0b, #fa6161);
    --sapButton_Accept_Background: light-dark(#ebf5cb, #153e20);
    --sapButton_Accept_BorderColor: light-dark(#dbeda0, #1b512a);
    --sapButton_Accept_TextColor: light-dark(#256f3a, #97dd40);
    --sapButton_Accept_Hover_Background: light-dark(#e3f1b6, #1b512a);
    --sapButton_Accept_Hover_BorderColor: light-dark(#e3f1b6, #1b512a);
    --sapButton_Accept_Hover_TextColor: light-dark(#256f3a, #97dd40);
    --sapButton_Accept_Active_Background: light-dark(#fff, #213131);
    --sapButton_Accept_Active_BorderColor: light-dark(#30914c, #6dad1f);
    --sapButton_Accept_Active_TextColor: light-dark(#256f3a, #97dd40);
    --sapButton_Accept_Selected_Background: light-dark(#fff, #213131);
    --sapButton_Accept_Selected_BorderColor: light-dark(#30914c, #6dad1f);
    --sapButton_Accept_Selected_TextColor: light-dark(#256f3a, #97dd40);
    --sapButton_Accept_Selected_Hover_Background: light-dark(#e3f1b6, #1b512a);
    --sapButton_Accept_Selected_Hover_BorderColor: light-dark(#30914c, #6dad1f);
    --sapButton_Lite_Background: transparent;
    --sapButton_Lite_BorderColor: transparent;
    --sapButton_Lite_TextColor: light-dark(#0064d9, #4db1ff);
    --sapButton_Lite_Hover_Background: light-dark(#eaecee, #222b35);
    --sapButton_Lite_Hover_BorderColor: light-dark(#bcc3ca, #3a4a5a);
    --sapButton_Lite_Hover_TextColor: light-dark(#0064d9, #4db1ff);
    --sapButton_Lite_Active_Background: light-dark(#fff, #213131);
    --sapButton_Lite_Active_BorderColor: light-dark(#0064d9, #4db1ff);
    --sapButton_Selected_Background: light-dark(#edf6ff, #002643);
    --sapButton_Selected_BorderColor: light-dark(#0064d9, #4db1ff);
    --sapButton_Selected_TextColor: light-dark(#0064d9, #4db1ff);
    --sapButton_Selected_Hover_Background: light-dark(#d9ecff, #002b4d);
    --sapButton_Selected_Hover_BorderColor: light-dark(#0064d9, #4db1ff);
    --sapButton_Attention_Background: light-dark(#fff3b7, #382700);
    --sapButton_Attention_BorderColor: light-dark(#ffeb84, #523900);
    --sapButton_Attention_TextColor: light-dark(#b44f00, #ffdf72);
    --sapButton_Attention_Hover_Background: light-dark(#ffef9e, #523900);
    --sapButton_Attention_Hover_BorderColor: light-dark(#ffef9e, #523900);
    --sapButton_Attention_Hover_TextColor: light-dark(#b44f00, #ffdf72);
    --sapButton_Attention_Active_Background: light-dark(#fff, #213131);
    --sapButton_Attention_Active_BorderColor: light-dark(#dd6100, #f7bf00);
    --sapButton_Attention_Active_TextColor: light-dark(#b44f00, #ffdf72);
    --sapButton_Attention_Selected_Background: light-dark(#fff, #213131);
    --sapButton_Attention_Selected_BorderColor: light-dark(#dd6100, #f7bf00);
    --sapButton_Attention_Selected_TextColor: light-dark(#b44f00, #ffdf72);
    --sapButton_Attention_Selected_Hover_Background: light-dark(#ffef9e, #523900);
    --sapButton_Attention_Selected_Hover_BorderColor: light-dark(#dd6100, #f7bf00);
    --sapButton_Negative_Background: light-dark(#f53232, #fa6161);
    --sapButton_Negative_BorderColor: light-dark(#f53232, #fa6161);
    --sapButton_Negative_TextColor: light-dark(#fff, #1d232a);
    --sapButton_Negative_Hover_Background: light-dark(#e90b0b, #fb7a7a);
    --sapButton_Negative_Hover_BorderColor: light-dark(#e90b0b, #fb7a7a);
    --sapButton_Negative_Hover_TextColor: light-dark(#fff, #1d232a);
    --sapButton_Negative_Active_Background: light-dark(#fff, #213131);
    --sapButton_Negative_Active_BorderColor: light-dark(#f53232, #fa6161);
    --sapButton_Negative_Active_TextColor: light-dark(#aa0808, #fa6161);
    --sapButton_Critical_Background: light-dark(#e76500, #f7bf00);
    --sapButton_Critical_BorderColor: light-dark(#e76500, #f7bf00);
    --sapButton_Critical_TextColor: light-dark(#fff, #1d232a);
    --sapButton_Critical_Hover_Background: light-dark(#dd6100, #ffcf2b);
    --sapButton_Critical_Hover_BorderColor: light-dark(#dd6100, #ffcf2b);
    --sapButton_Critical_Hover_TextColor: light-dark(#fff, #1d232a);
    --sapButton_Critical_Active_Background: light-dark(#fff, #213131);
    --sapButton_Critical_Active_BorderColor: light-dark(#dd6100, #f7bf00);
    --sapButton_Critical_Active_TextColor: light-dark(#b44f00, #ffdf72);
    --sapButton_Success_Background: light-dark(#30914c, #6dad1f);
    --sapButton_Success_BorderColor: light-dark(#30914c, #6dad1f);
    --sapButton_Success_TextColor: light-dark(#fff, #1d232a);
    --sapButton_Success_Hover_Background: light-dark(#2c8646, #7bc323);
    --sapButton_Success_Hover_BorderColor: light-dark(#2c8646, #7bc323);
    --sapButton_Success_Hover_TextColor: light-dark(#fff, #1d232a);
    --sapButton_Success_Active_Background: light-dark(#fff, #213131);
    --sapButton_Success_Active_BorderColor: light-dark(#30914c, #6dad1f);
    --sapButton_Success_Active_TextColor: light-dark(#256f3a, #97dd40);
    --sapButton_Information_Background: light-dark(#e8f3ff, #002b4d);
    --sapButton_Information_BorderColor: light-dark(#b5d8ff, #00457b);
    --sapButton_Information_TextColor: light-dark(#0064d9, #4db1ff);
    --sapButton_Information_Hover_Background: light-dark(#d4e8ff, #003967);
    --sapButton_Information_Hover_BorderColor: light-dark(#b5d8ff, #00457b);
    --sapButton_Information_Hover_TextColor: light-dark(#0064d9, #4db1ff);
    --sapButton_Information_Active_Background: light-dark(#fff, #213131);
    --sapButton_Information_Active_BorderColor: light-dark(#0064d9, #4db1ff);
    --sapButton_Information_Active_TextColor: light-dark(#0064d9, #4db1ff);
    --sapButton_Neutral_Background: light-dark(#e8f3ff, #002b4d);
    --sapButton_Neutral_BorderColor: light-dark(#b5d8ff, #00457b);
    --sapButton_Neutral_TextColor: light-dark(#0064d9, #4db1ff);
    --sapButton_Neutral_Hover_Background: light-dark(#d4e8ff, #003967);
    --sapButton_Neutral_Hover_BorderColor: light-dark(#b5d8ff, #00457b);
    --sapButton_Neutral_Hover_TextColor: light-dark(#0064d9, #4db1ff);
    --sapButton_Neutral_Active_Background: light-dark(#fff, #213131);
    --sapButton_Neutral_Active_BorderColor: light-dark(#0064d9, #4db1ff);
    --sapButton_Neutral_Active_TextColor: light-dark(#0064d9, #4db1ff);
    --sapButton_Track_Background: light-dark(#788fa6, #a9b4be);
    --sapButton_Track_BorderColor: light-dark(#788fa6, #a9b4be);
    --sapButton_Track_TextColor: light-dark(#fff, #1d232a);
    --sapButton_Track_Hover_Background: light-dark(#637d97, #b8c1c9);
    --sapButton_Track_Hover_BorderColor: light-dark(#637d97, #b8c1c9);
    --sapButton_Track_Selected_Background: light-dark(#0064d9, #4db1ff);
    --sapButton_Track_Selected_BorderColor: light-dark(#0064d9, #4db1ff);
    --sapButton_Track_Selected_TextColor: light-dark(#fff, #1d232a);
    --sapButton_Track_Selected_Hover_Background: light-dark(#0058c0, #67bcff);
    --sapButton_Track_Selected_Hover_BorderColor: light-dark(#0058c0, #67bcff);
    --sapButton_Handle_Background: light-dark(#fff, #1d232a);
    --sapButton_Handle_BorderColor: light-dark(#fff, #1d232a);
    --sapButton_Handle_TextColor: light-dark(#131e29, #f5f6f7);
    --sapButton_Handle_Hover_Background: light-dark(#fff, #1d232a);
    --sapButton_Handle_Hover_BorderColor: light-dark(rgba(255,255,255,.5), rgba(29,35,42,.5));
    --sapButton_Handle_Selected_Background: light-dark(#edf6ff, #002643);
    --sapButton_Handle_Selected_BorderColor: light-dark(#edf6ff, #002643);
    --sapButton_Handle_Selected_TextColor: light-dark(#0064d9, #4db1ff);
    --sapButton_Handle_Selected_Hover_Background: light-dark(#edf6ff, #002643);
    --sapButton_Handle_Selected_Hover_BorderColor: light-dark(rgba(237,246,255,.5), rgba(0,38,67,.5));
    --sapButton_Track_Negative_Background: light-dark(#f53232, #fa6161);
    --sapButton_Track_Negative_BorderColor: light-dark(#f53232, #fa6161);
    --sapButton_Track_Negative_TextColor: light-dark(#fff, #1d232a);
    --sapButton_Track_Negative_Hover_Background: light-dark(#e90b0b, #fb7a7a);
    --sapButton_Track_Negative_Hover_BorderColor: light-dark(#e90b0b, #fb7a7a);
    --sapButton_Handle_Negative_Background: light-dark(#fff, #1d232a);
    --sapButton_Handle_Negative_BorderColor: light-dark(#fff, #1d232a);
    --sapButton_Handle_Negative_TextColor: light-dark(#aa0808, #fa6161);
    --sapButton_Handle_Negative_Hover_Background: light-dark(#fff, #1d232a);
    --sapButton_Handle_Negative_Hover_BorderColor: light-dark(rgba(255,255,255,.5), rgba(29,35,42,.5));
    --sapButton_Track_Positive_Background: light-dark(#30914c, #6dad1f);
    --sapButton_Track_Positive_BorderColor: light-dark(#30914c, #6dad1f);
    --sapButton_Track_Positive_TextColor: light-dark(#fff, #1d232a);
    --sapButton_Track_Positive_Hover_Background: light-dark(#2c8646, #7bc323);
    --sapButton_Track_Positive_Hover_BorderColor: light-dark(#2c8646, #7bc323);
    --sapButton_Handle_Positive_Background: light-dark(#fff, #1d232a);
    --sapButton_Handle_Positive_BorderColor: light-dark(#fff, #1d232a);
    --sapButton_Handle_Positive_TextColor: light-dark(#256f3a, #97dd40);
    --sapButton_Handle_Positive_Hover_Background: light-dark(#fff, #1d232a);
    --sapButton_Handle_Positive_Hover_BorderColor: light-dark(rgba(255,255,255,.5), rgba(29,35,42,.5));
    --sapButton_TokenBackground: light-dark(#fff, #1c242c);
    --sapButton_TokenBorderColor: light-dark(#bcc3ca, #3a4a5a);
    --sapButton_TokenBorderCornerRadius: .375rem;
    --sapButton_Selected_TokenBorderWidth: .0625rem;
    --sapButton_ReadOnly_TokenBackground: light-dark(#fff, #1c242c);
    --sapButton_Segment_BorderCornerRadius: .5rem;
    --sapField_Background: light-dark(#fff, #161c22);
    --sapField_BackgroundStyle: var(--_ui5-light-scheme, 0 100% / 100% .0625rem no-repeat linear-gradient(0deg, #556b81, #556b81) border-box) var(--_ui5-dark-scheme, 0 100% / 100% .0625rem no-repeat linear-gradient(0deg, #a9b4be, #a9b4be) border-box);
    --sapField_TextColor: light-dark(#131e29, #fff);
    --sapField_PlaceholderTextColor: light-dark(#556b82, #8396A8);
    --sapField_BorderColor: light-dark(#556b81, #a9b4be);
    --sapField_HelpBackground: light-dark(#fff, #161c22);
    --sapField_BorderWidth: .0625rem;
    --sapField_BorderStyle: none;
    --sapField_BorderCornerRadius: .25rem;
    --sapField_Shadow: var(--_ui5-light-scheme, inset 0 0 0 .0625rem rgba(85,107,129,.25)) var(--_ui5-dark-scheme, inset 0 0 0 .0625rem rgba(169,180,190,.25));
    --sapField_Hover_Background: light-dark(#fff, #1d232a);
    --sapField_Hover_BackgroundStyle: var(--_ui5-light-scheme, 0 100% / 100% .0625rem no-repeat linear-gradient(0deg, #0064d9, #0064d9) border-box) var(--_ui5-dark-scheme, 0 100% / 100% .0625rem no-repeat linear-gradient(0deg, #4db1ff, #4db1ff) border-box);
    --sapField_Hover_BorderColor: light-dark(#0064d9, #4db1ff);
    --sapField_Hover_HelpBackground: light-dark(#fff, #1d232a);
    --sapField_Hover_Shadow: var(--_ui5-light-scheme, inset 0 0 0 .0625rem rgba(79,160,255,.5)) var(--_ui5-dark-scheme, inset 0 0 0 .0625rem rgba(77,177,255,.3));
    --sapField_Hover_InvalidShadow: var(--_ui5-light-scheme, inset 0 0 0 .0625rem rgba(255,142,196,.45)) var(--_ui5-dark-scheme, inset 0 0 0 .0625rem rgba(248,38,38,.3));
    --sapField_Hover_WarningShadow: var(--_ui5-light-scheme, inset 0 0 0 .0625rem rgba(255,213,10,.4)) var(--_ui5-dark-scheme, inset 0 0 0 .0625rem rgba(132,92,0,.5));
    --sapField_Hover_SuccessShadow: var(--_ui5-light-scheme, inset 0 0 0 .0625rem rgba(48,145,76,.18)) var(--_ui5-dark-scheme, inset 0 0 0 .0625rem rgba(109,173,31,.18));
    --sapField_Hover_InformationShadow: var(--_ui5-light-scheme, inset 0 0 0 .0625rem rgba(104,174,255,.5)) var(--_ui5-dark-scheme, inset 0 0 0 .0625rem rgba(77,177,255,.3));
    --sapField_Active_BorderColor: light-dark(#0064d9, #4db1ff);
    --sapField_Focus_Background: light-dark(#fff, #1d232a);
    --sapField_Focus_BorderColor: light-dark(#0032a5, #9ad3ff);
    --sapField_Focus_HelpBackground: light-dark(#fff, #1d232a);
    --sapField_ReadOnly_Background: light-dark(#eaecee, #242e38);
    --sapField_ReadOnly_BackgroundStyle: var(--_ui5-light-scheme, 0 100% / .375rem .0625rem repeat-x linear-gradient(90deg, #556b81 0, #556b81 .25rem, transparent .25rem) border-box) var(--_ui5-dark-scheme, 0 100% / .375rem .0625rem repeat-x linear-gradient(90deg, #a9b4be 0, #a9b4be .25rem, transparent .25rem) border-box);
    --sapField_ReadOnly_BorderColor: light-dark(#556b81, #a9b4be);
    --sapField_ReadOnly_BorderStyle: none;
    --sapField_ReadOnly_HelpBackground: light-dark(#eaecee, #242e38);
    --sapField_RequiredColor: light-dark(#ba066c, #ff78a4);
    --sapField_InvalidColor: light-dark(#e90b0b, #fa6161);
    --sapField_InvalidBackground: light-dark(#ffeaf4, #350000);
    --sapField_InvalidBackgroundStyle: var(--_ui5-light-scheme, 0 100% / 100% .125rem no-repeat linear-gradient(0deg, #e90b0b, #e90b0b) border-box) var(--_ui5-dark-scheme, 0 100% / 100% .125rem no-repeat linear-gradient(0deg, #fa6161, #fa6161) border-box);
    --sapField_InvalidBorderWidth: .125rem;
    --sapField_InvalidBorderStyle: none;
    --sapField_InvalidShadow: var(--_ui5-light-scheme, inset 0 0 0 .0625rem rgba(255,142,196,.45)) var(--_ui5-dark-scheme, inset 0 0 0 .0625rem rgba(248,38,38,.3));
    --sapField_WarningColor: light-dark(#dd6100, #f7bf00);
    --sapField_WarningBackground: light-dark(#fff8d6, #382700);
    --sapField_WarningBackgroundStyle: var(--_ui5-light-scheme, 0 100% / 100% .125rem no-repeat linear-gradient(0deg, #dd6100, #dd6100) border-box) var(--_ui5-dark-scheme, 0 100% / 100% .125rem no-repeat linear-gradient(0deg, #f7bf00, #f7bf00) border-box);
    --sapField_WarningBorderWidth: .125rem;
    --sapField_WarningBorderStyle: none;
    --sapField_WarningShadow: var(--_ui5-light-scheme, inset 0 0 0 .0625rem rgba(255,213,10,.4)) var(--_ui5-dark-scheme, inset 0 0 0 .0625rem rgba(132,92,0,.5));
    --sapField_SuccessColor: light-dark(#30914c, #6dad1f);
    --sapField_SuccessBackground: light-dark(#f5fae5, #11331a);
    --sapField_SuccessBackgroundStyle: var(--_ui5-light-scheme, 0 100% / 100% .0625rem no-repeat linear-gradient(0deg, #30914c, #30914c) border-box) var(--_ui5-dark-scheme, 0 100% / 100% .0625rem no-repeat linear-gradient(0deg, #6dad1f, #6dad1f) border-box);
    --sapField_SuccessBorderWidth: .0625rem;
    --sapField_SuccessBorderStyle: none;
    --sapField_SuccessShadow: var(--_ui5-light-scheme, inset 0 0 0 .0625rem rgba(48,145,76,.18)) var(--_ui5-dark-scheme, inset 0 0 0 .0625rem rgba(109,173,31,.18));
    --sapField_InformationColor: light-dark(#0070f2, #4db1ff);
    --sapField_InformationBackground: light-dark(#e1f4ff, #00144a);
    --sapField_InformationBackgroundStyle: var(--_ui5-light-scheme, 0 100% / 100% .125rem no-repeat linear-gradient(0deg, #0070f2, #0070f2) border-box) var(--_ui5-dark-scheme, 0 100% / 100% .125rem no-repeat linear-gradient(0deg, #4db1ff, #4db1ff) border-box);
    --sapField_InformationBorderWidth: .125rem;
    --sapField_InformationBorderStyle: none;
    --sapField_InformationShadow: var(--_ui5-light-scheme, inset 0 0 0 .0625rem rgba(104,174,255,.5)) var(--_ui5-dark-scheme, inset 0 0 0 .0625rem rgba(77,177,255,.3));
    --sapField_Selector_Hover_Background: light-dark(#e3f0ff, #002b4d);
    --sapField_Selector_Hover_InvalidBackground: light-dark(#fff, #1d232a);
    --sapField_Selector_Hover_WarningBackground: light-dark(#fff, #1d232a);
    --sapField_Selector_Hover_SuccessBackground: light-dark(#fff, #1d232a);
    --sapField_Selector_Hover_InformationBackground: light-dark(#fff, #1d232a);
    --sapField_Picker_BorderColor: light-dark(#556b81, #a9b4be);
    --sapField_Picker_BorderWidth: .0625rem;
    --sapField_Selector_BorderStyle: solid;
    --sapField_Selector_ReadOnly_BorderStyle: dashed;
    --sapField_Selector_InvalidBorderStyle: solid;
    --sapField_Selector_WarningBorderStyle: solid;
    --sapField_Selector_SuccessBorderStyle: solid;
    --sapField_Selector_InformationBorderStyle: solid;
    --sapGroup_TitleBorderWidth: .0625rem;
    --sapGroup_TitleBackground: light-dark(#fff, #1d232a);
    --sapGroup_TitleBorderColor: light-dark(#a8b2bd, #768ea5);
    --sapGroup_TitleTextColor: light-dark(#131e29, #f5f6f7);
    --sapGroup_Title_FontSize: 1rem;
    --sapGroup_ContentBackground: light-dark(#fff, #1d232a);
    --sapGroup_ContentBorderColor: light-dark(#d9d9d9, #323c48);
    --sapGroup_BorderWidth: .0625rem;
    --sapGroup_BorderCornerRadius: .75rem;
    --sapGroup_FooterBackground: transparent;
    --sapToolbar_Background: light-dark(#fff, #1d232a);
    --sapToolbar_SeparatorColor: light-dark(#d9d9d9, #3c4957);
    --sapList_HeaderBackground: light-dark(#fff, #1d232a);
    --sapList_HeaderBorderColor: light-dark(#a8b2bd, #768ea5);
    --sapList_HeaderTextColor: light-dark(#131e29, #f5f6f7);
    --sapList_BorderColor: light-dark(#e5e5e5, #2e3742);
    --sapList_BorderWidth: .0625rem;
    --sapList_TextColor: light-dark(#131e29, #f5f6f7);
    --sapList_Active_TextColor: light-dark(#131e29, #f5f6f7);
    --sapList_Active_Background: light-dark(#dee2e5, #020303);
    --sapList_SelectionBackgroundColor: light-dark(#ebf8ff, #1d2d3e);
    --sapList_SelectionBorderColor: light-dark(#0064d9, #4db1ff);
    --sapList_Hover_SelectionBackground: light-dark(#dcf3ff, #223548);
    --sapList_Background: light-dark(#fff, #1d232a);
    --sapList_Hover_Background: light-dark(#eaecee, #222b35);
    --sapList_AlternatingBackground: light-dark(#f5f6f7, #12171c);
    --sapList_GroupHeaderBackground: light-dark(#fff, #1d232a);
    --sapList_GroupHeaderBorderColor: light-dark(#a8b2bd, #768ea5);
    --sapList_GroupHeaderTextColor: light-dark(#131e29, #f5f6f7);
    --sapList_TableGroupHeaderBackground: light-dark(#eff1f2, #0c0f13);
    --sapList_TableGroupHeaderBorderColor: light-dark(#a8b2bd, #768ea5);
    --sapList_TableGroupHeaderTextColor: light-dark(#131e29, #f5f6f7);
    --sapList_FooterBackground: light-dark(#fff, #1d232a);
    --sapList_FooterTextColor: light-dark(#131e29, #f5f6f7);
    --sapList_TableFooterBorder: light-dark(#a8b2bd, #768ea5);
    --sapList_TableFixedBorderColor: light-dark(#8c8c8c, #6f829a);
    --sapList_TableFixedColumnBorderWidth: .0625rem;
    --sapList_TableFixedRowBorderWidth: .125rem;
    --sapMessage_BorderWidth: .0625rem;
    --sapMessage_ErrorBorderColor: light-dark(#ff8ec4, #910000);
    --sapMessage_WarningBorderColor: light-dark(#ffe770, #845c00);
    --sapMessage_SuccessBorderColor: light-dark(#cee67e, #246c37);
    --sapMessage_InformationBorderColor: light-dark(#7bcfff, #0034bf);
    --sapMessage_Button_Hover_Background: light-dark(rgba(234,236,238,.2), rgba(34,43,53,.2));
    --sapPopover_BorderCornerRadius: .5rem;
    --sapProgress_Background: light-dark(#d5dadd, #2e3b48);
    --sapProgress_BorderColor: light-dark(#d5dadd, #2e3b48);
    --sapProgress_TextColor: light-dark(#131e29, #f5f6f7);
    --sapProgress_FontSize: .875rem;
    --sapProgress_NegativeBackground: light-dark(#ffdbec, #680000);
    --sapProgress_NegativeBorderColor: light-dark(#ffdbec, #680000);
    --sapProgress_NegativeTextColor: light-dark(#131e29, #f5f6f7);
    --sapProgress_CriticalBackground: light-dark(#fff4bd, #6b4b00);
    --sapProgress_CriticalBorderColor: light-dark(#fff4bd, #6b4b00);
    --sapProgress_CriticalTextColor: light-dark(#131e29, #f5f6f7);
    --sapProgress_PositiveBackground: light-dark(#e5f2ba, #174624);
    --sapProgress_PositiveBorderColor: light-dark(#e5f2ba, #174624);
    --sapProgress_PositiveTextColor: light-dark(#131e29, #f5f6f7);
    --sapProgress_InformationBackground: light-dark(#cdedff, #001b64);
    --sapProgress_InformationBorderColor: light-dark(#cdedff, #001b64);
    --sapProgress_InformationTextColor: light-dark(#131e29, #f5f6f7);
    --sapProgress_Value_Background: light-dark(#617b94, #a9b4be);
    --sapProgress_Value_BorderColor: light-dark(#617b94, #a9b4be);
    --sapProgress_Value_TextColor: light-dark(#788fa6, #a9b4be);
    --sapProgress_Value_NegativeBackground: light-dark(#f53232, #fa6161);
    --sapProgress_Value_NegativeBorderColor: light-dark(#f53232, #fa6161);
    --sapProgress_Value_NegativeTextColor: light-dark(#f53232, #fa6161);
    --sapProgress_Value_CriticalBackground: light-dark(#e76500, #f7bf00);
    --sapProgress_Value_CriticalBorderColor: light-dark(#e76500, #f7bf00);
    --sapProgress_Value_CriticalTextColor: light-dark(#e76500, #f7bf00);
    --sapProgress_Value_PositiveBackground: light-dark(#30914c, #6dad1f);
    --sapProgress_Value_PositiveBorderColor: light-dark(#30914c, #6dad1f);
    --sapProgress_Value_PositiveTextColor: light-dark(#30914c, #6dad1f);
    --sapProgress_Value_InformationBackground: light-dark(#0070f2, #4db1ff);
    --sapProgress_Value_InformationBorderColor: light-dark(#0070f2, #4db1ff);
    --sapProgress_Value_InformationTextColor: light-dark(#0070f2, #4db1ff);
    --sapScrollBar_FaceColor: light-dark(#7b91a8, #647891);
    --sapScrollBar_TrackColor: light-dark(#fff, #1d232a);
    --sapScrollBar_BorderColor: light-dark(#7b91a8, #647891);
    --sapScrollBar_SymbolColor: light-dark(#0064d9, #4db1ff);
    --sapScrollBar_Dimension: .75rem;
    --sapScrollBar_Hover_FaceColor: light-dark(#5b728b, #8697ac);
    --sapSlider_Background: light-dark(#d5dadd, #2e3b48);
    --sapSlider_BorderColor: light-dark(#d5dadd, #2e3b48);
    --sapSlider_Selected_Background: light-dark(#0064d9, #4db1ff);
    --sapSlider_Selected_BorderColor: light-dark(#0064d9, #4db1ff);
    --sapSlider_Selected_Dimension: .125rem;
    --sapSlider_HandleBackground: light-dark(#fff, #1d232a);
    --sapSlider_HandleBorderColor: light-dark(#b0d5ff, #005394);
    --sapSlider_RangeHandleBackground: light-dark(#fff, #1d232a);
    --sapSlider_Hover_HandleBackground: light-dark(#d9ecff, #002b4d);
    --sapSlider_Hover_HandleBorderColor: light-dark(#b0d5ff, #005394);
    --sapSlider_Hover_RangeHandleBackground: light-dark(#d9ecff, #002b4d);
    --sapSlider_Active_HandleBackground: light-dark(#fff, #213131);
    --sapSlider_Active_HandleBorderColor: light-dark(#0064d9, #4db1ff);
    --sapSlider_Active_RangeHandleBackground: transparent;
    --sapPageHeader_Background: light-dark(#fff, #1d232a);
    --sapPageHeader_BorderColor: light-dark(#d9d9d9, #2e3742);
    --sapPageHeader_TextColor: light-dark(#131e29, #f5f6f7);
    --sapPageFooter_Background: light-dark(#fff, #1d232a);
    --sapPageFooter_BorderColor: light-dark(#d9d9d9, #2e3742);
    --sapPageFooter_TextColor: light-dark(#131e29, #f5f6f7);
    --sapInfobar_Background: light-dark(#c2fcee, #036573);
    --sapInfobar_Hover_Background: light-dark(#fff, #1d232a);
    --sapInfobar_Active_Background: light-dark(#fff, #1d232a);
    --sapInfobar_NonInteractive_Background: light-dark(#f5f6f7, #12171c);
    --sapInfobar_TextColor: light-dark(#046c7a, #64edd2);
    --sapObjectHeader_Background: light-dark(#fff, #1d232a);
    --sapObjectHeader_Hover_Background: light-dark(#eaecee, #222b35);
    --sapObjectHeader_BorderColor: light-dark(#d9d9d9, #2e3742);
    --sapObjectHeader_Title_TextColor: light-dark(#131e29, #f5f6f7);
    --sapObjectHeader_Title_FontSize: 1.5rem;
    --sapObjectHeader_Title_SnappedFontSize: 1.25rem;
    --sapObjectHeader_Title_FontFamily: "72Black", "72Blackfull","72", "72full", Arial, Helvetica, sans-serif;
    --sapObjectHeader_Subtitle_TextColor: light-dark(#556b82, #8396a8);
    --sapBlockLayer_Background: #000;
    --sapBlockLayer_Opacity: .2;
    --sapTab_TextColor: light-dark(#131e29, #f5f6f7);
    --sapTab_ForegroundColor: light-dark(#0064d9, #4db1ff);
    --sapTab_IconColor: light-dark(#0064d9, #4db1ff);
    --sapTab_Background: light-dark(#fff, #1d232a);
    --sapTab_Selected_TextColor: light-dark(#0064d9, #4db1ff);
    --sapTab_Selected_IconColor: light-dark(#fff, #1d232a);
    --sapTab_Selected_Background: light-dark(#0064d9, #4db1ff);
    --sapTab_Selected_Indicator_Dimension: .1875rem;
    --sapTab_Positive_TextColor: light-dark(#256f3a, #97dd40);
    --sapTab_Positive_ForegroundColor: light-dark(#30914c, #6dad1f);
    --sapTab_Positive_IconColor: light-dark(#30914c, #6dad1f);
    --sapTab_Positive_Selected_TextColor: light-dark(#256f3a, #97dd40);
    --sapTab_Positive_Selected_IconColor: light-dark(#fff, #1d232a);
    --sapTab_Positive_Selected_Background: light-dark(#30914c, #6dad1f);
    --sapTab_Negative_TextColor: light-dark(#aa0808, #fa6161);
    --sapTab_Negative_ForegroundColor: light-dark(#f53232, #fa6161);
    --sapTab_Negative_IconColor: light-dark(#f53232, #fa6161);
    --sapTab_Negative_Selected_TextColor: light-dark(#aa0808, #fa6161);
    --sapTab_Negative_Selected_IconColor: light-dark(#fff, #1d232a);
    --sapTab_Negative_Selected_Background: light-dark(#f53232, #fa6161);
    --sapTab_Critical_TextColor: light-dark(#b44f00, #ffdf72);
    --sapTab_Critical_ForegroundColor: light-dark(#e76500, #f7bf00);
    --sapTab_Critical_IconColor: light-dark(#e76500, #f7bf00);
    --sapTab_Critical_Selected_TextColor: light-dark(#b44f00, #ffdf72);
    --sapTab_Critical_Selected_IconColor: light-dark(#fff, #1d232a);
    --sapTab_Critical_Selected_Background: light-dark(#e76500, #f7bf00);
    --sapTab_Neutral_TextColor: light-dark(#131e29, #f5f6f7);
    --sapTab_Neutral_ForegroundColor: light-dark(#788fa6, #a9b4be);
    --sapTab_Neutral_IconColor: light-dark(#788fa6, #a9b4be);
    --sapTab_Neutral_Selected_TextColor: light-dark(#131e29, #f5f6f7);
    --sapTab_Neutral_Selected_IconColor: light-dark(#fff, #1d232a);
    --sapTab_Neutral_Selected_Background: light-dark(#788fa6, #a9b4be);
    --sapTile_Background: light-dark(#fff, #1d232a);
    --sapTile_Hover_Background: light-dark(#eaecee, #222b35);
    --sapTile_Active_Background: light-dark(#dee2e5, #020303);
    --sapTile_BorderColor: transparent;
    --sapTile_BorderCornerRadius: 1rem;
    --sapTile_TitleTextColor: light-dark(#131e29, #f5f6f7);
    --sapTile_TextColor: light-dark(#556b82, #8396a8);
    --sapTile_IconColor: light-dark(#556b82, #8396a8);
    --sapTile_SeparatorColor: transparent;
    --sapTile_Interactive_BorderColor: light-dark(#b3b3b3, #5b6e85);
    --sapTile_OverlayBackground: light-dark(#fff, #1d232a);
    --sapTile_OverlayForegroundColor: light-dark(#131e29, #f5f6f7);
    --sapTile_Hover_ContentBackground: light-dark(#fff, #1d232a);
    --sapTile_Active_ContentBackground: light-dark(#fff, #1d232a);
    --sapAccentColor1: light-dark(#d27700, #ffdf72);
    --sapAccentColor2: light-dark(#aa0808, #ff8cb2);
    --sapAccentColor3: light-dark(#ba066c, #fecbda);
    --sapAccentColor4: light-dark(#a100c2, #ffafed);
    --sapAccentColor5: light-dark(#5d36ff, #d3b6ff);
    --sapAccentColor6: light-dark(#0057d2, #a6e0ff);
    --sapAccentColor7: light-dark(#046c7a, #64edd2);
    --sapAccentColor8: light-dark(#256f3a, #bde986);
    --sapAccentColor9: light-dark(#6c32a9, #b995e0);
    --sapAccentColor10: light-dark(#5b738b, #d5dadd);
    --sapAccentBackgroundColor1: light-dark(#fff3b8, #ae4000);
    --sapAccentBackgroundColor2: light-dark(#ffd0e7, #890506);
    --sapAccentBackgroundColor3: light-dark(#ffdbe7, #b40569);
    --sapAccentBackgroundColor4: light-dark(#ffdcf3, #8700b8);
    --sapAccentBackgroundColor5: light-dark(#ded3ff, #470cf1);
    --sapAccentBackgroundColor6: light-dark(#d1efff, #0054cc);
    --sapAccentBackgroundColor7: light-dark(#c2fcee, #036573);
    --sapAccentBackgroundColor8: light-dark(#ebf5cb, #236c39);
    --sapAccentBackgroundColor9: light-dark(#ddccf0, #4e247a);
    --sapAccentBackgroundColor10: light-dark(#eaecee, #45617c);
    --sapIndicationColor_1: light-dark(#840606, #fd4444);
    --sapIndicationColor_1_Background: light-dark(#840606, #fd4444);
    --sapIndicationColor_1_BorderColor: light-dark(#840606, #fd4444);
    --sapIndicationColor_1_TextColor: light-dark(#fff, #1d232a);
    --sapIndicationColor_1_Hover_Background: light-dark(#6c0505, #fd5d5d);
    --sapIndicationColor_1_Active_Background: light-dark(#fff, #213131);
    --sapIndicationColor_1_Active_BorderColor: light-dark(#fb9d9d, #5e0303);
    --sapIndicationColor_1_Active_TextColor: light-dark(#840606, #fd4444);
    --sapIndicationColor_1_Selected_Background: light-dark(#fff, #213131);
    --sapIndicationColor_1_Selected_BorderColor: light-dark(#fb9d9d, #5e0303);
    --sapIndicationColor_1_Selected_TextColor: light-dark(#840606, #fd4444);
    --sapIndicationColor_1b: light-dark(#fb9d9d, #5e0303);
    --sapIndicationColor_1b_TextColor: light-dark(#830707, #fd4444);
    --sapIndicationColor_1b_Background: light-dark(#fb9d9d, #5e0303);
    --sapIndicationColor_1b_BorderColor: light-dark(#fb9d9d, #5e0303);
    --sapIndicationColor_1b_Hover_Background: light-dark(#fa8585, #770404);
    --sapIndicationColor_2: light-dark(#aa0808, #ff8f8f);
    --sapIndicationColor_2_Background: light-dark(#aa0808, #ff8f8f);
    --sapIndicationColor_2_BorderColor: light-dark(#aa0808, #ff8f8f);
    --sapIndicationColor_2_TextColor: light-dark(#fff, #1d232a);
    --sapIndicationColor_2_Hover_Background: light-dark(#920707, #ffa9a9);
    --sapIndicationColor_2_Active_Background: light-dark(#fff, #213131);
    --sapIndicationColor_2_Active_BorderColor: light-dark(#fcc4c4, #7d0000);
    --sapIndicationColor_2_Active_TextColor: light-dark(#aa0808, #ff8f8f);
    --sapIndicationColor_2_Selected_Background: light-dark(#fff, #213131);
    --sapIndicationColor_2_Selected_BorderColor: light-dark(#fcc4c4, #7d0000);
    --sapIndicationColor_2_Selected_TextColor: light-dark(#aa0808, #ff8f8f);
    --sapIndicationColor_2b: light-dark(#fcc4c4, #7d0000);
    --sapIndicationColor_2b_TextColor: light-dark(#a90909, #ff8c8c);
    --sapIndicationColor_2b_Background: light-dark(#fcc4c4, #7d0000);
    --sapIndicationColor_2b_BorderColor: light-dark(#fcc4c4, #7d0000);
    --sapIndicationColor_2b_Hover_Background: light-dark(#fbacac, #970000);
    --sapIndicationColor_3: light-dark(#b95100, #ffc933);
    --sapIndicationColor_3_Background: light-dark(#e76500, #ffc933);
    --sapIndicationColor_3_BorderColor: light-dark(#e76500, #ffc933);
    --sapIndicationColor_3_TextColor: light-dark(#fff, #1d232a);
    --sapIndicationColor_3_Hover_Background: light-dark(#d85e00, #ffcd42);
    --sapIndicationColor_3_Active_Background: light-dark(#fff, #213131);
    --sapIndicationColor_3_Active_BorderColor: light-dark(#ffdfc3, #640);
    --sapIndicationColor_3_Active_TextColor: light-dark(#b95100, #ffc933);
    --sapIndicationColor_3_Selected_Background: light-dark(#fff, #213131);
    --sapIndicationColor_3_Selected_BorderColor: light-dark(#ffdfc3, #640);
    --sapIndicationColor_3_Selected_TextColor: light-dark(#b95100, #ffc933);
    --sapIndicationColor_3b: light-dark(#ffdfc3, #640);
    --sapIndicationColor_3b_TextColor: light-dark(#a44d00, #fb3);
    --sapIndicationColor_3b_Background: light-dark(#ffdfc3, #640);
    --sapIndicationColor_3b_BorderColor: light-dark(#ffdfc3, #640);
    --sapIndicationColor_3b_Hover_Background: light-dark(#ffd1a9, #805500);
    --sapIndicationColor_4: light-dark(#256f3a, #bde986);
    --sapIndicationColor_4_Background: light-dark(#256f3a, #bde986);
    --sapIndicationColor_4_BorderColor: light-dark(#256f3a, #bde986);
    --sapIndicationColor_4_TextColor: light-dark(#fff, #1d232a);
    --sapIndicationColor_4_Hover_Background: light-dark(#1f5c30, #c9ed9c);
    --sapIndicationColor_4_Active_Background: light-dark(#fff, #213131);
    --sapIndicationColor_4_Active_BorderColor: light-dark(#bae8bc, #1b4a04);
    --sapIndicationColor_4_Active_TextColor: light-dark(#256f3a, #bde986);
    --sapIndicationColor_4_Selected_Background: light-dark(#fff, #213131);
    --sapIndicationColor_4_Selected_BorderColor: light-dark(#bae8bc, #1b4a04);
    --sapIndicationColor_4_Selected_TextColor: light-dark(#256f3a, #bde986);
    --sapIndicationColor_4b: light-dark(#bae8bc, #1b4a04);
    --sapIndicationColor_4b_TextColor: light-dark(#256f28, #a8e987);
    --sapIndicationColor_4b_Background: light-dark(#bae8bc, #1b4a04);
    --sapIndicationColor_4b_BorderColor: light-dark(#bae8bc, #1b4a04);
    --sapIndicationColor_4b_Hover_Background: light-dark(#a7e2a9, #246205);
    --sapIndicationColor_5: light-dark(#0070f2, #a6e0ff);
    --sapIndicationColor_5_Background: light-dark(#0070f2, #a6e0ff);
    --sapIndicationColor_5_BorderColor: light-dark(#0070f2, #a6e0ff);
    --sapIndicationColor_5_TextColor: light-dark(#fff, #1d232a);
    --sapIndicationColor_5_Hover_Background: light-dark(#0064d9, #c0e9ff);
    --sapIndicationColor_5_Active_Background: light-dark(#fff, #213131);
    --sapIndicationColor_5_Active_BorderColor: light-dark(#d9ebff, #024594);
    --sapIndicationColor_5_Active_TextColor: light-dark(#0070f2, #a6e0ff);
    --sapIndicationColor_5_Selected_Background: light-dark(#fff, #213131);
    --sapIndicationColor_5_Selected_BorderColor: light-dark(#d9ebff, #024594);
    --sapIndicationColor_5_Selected_TextColor: light-dark(#0070f2, #a6e0ff);
    --sapIndicationColor_5b: light-dark(#d9ebff, #024594);
    --sapIndicationColor_5b_TextColor: light-dark(#0067d9, #aad1ff);
    --sapIndicationColor_5b_Background: light-dark(#d9ebff, #024594);
    --sapIndicationColor_5b_BorderColor: light-dark(#d9ebff, #024594);
    --sapIndicationColor_5b_Hover_Background: light-dark(#c0deff, #0251ad);
    --sapIndicationColor_6: light-dark(#046c7a, #64edd2);
    --sapIndicationColor_6_Background: light-dark(#046c7a, #64edd2);
    --sapIndicationColor_6_BorderColor: light-dark(#046c7a, #64edd2);
    --sapIndicationColor_6_TextColor: light-dark(#fff, #1d232a);
    --sapIndicationColor_6_Hover_Background: light-dark(#035661, #7bf0d9);
    --sapIndicationColor_6_Active_Background: light-dark(#fff, #213131);
    --sapIndicationColor_6_Active_BorderColor: light-dark(#cdf5ec, #00454e);
    --sapIndicationColor_6_Active_TextColor: light-dark(#046c7a, #64edd2);
    --sapIndicationColor_6_Selected_Background: light-dark(#fff, #213131);
    --sapIndicationColor_6_Selected_BorderColor: light-dark(#cdf5ec, #00454e);
    --sapIndicationColor_6_Selected_TextColor: light-dark(#046c7a, #64edd2);
    --sapIndicationColor_6b: light-dark(#cdf5ec, #00454e);
    --sapIndicationColor_6b_TextColor: light-dark(#156b58, #65deed);
    --sapIndicationColor_6b_Background: light-dark(#cdf5ec, #00454e);
    --sapIndicationColor_6b_BorderColor: light-dark(#cdf5ec, #00454e);
    --sapIndicationColor_6b_Hover_Background: light-dark(#b8f1e4, #005c68);
    --sapIndicationColor_7: light-dark(#5d36ff, #d3b6ff);
    --sapIndicationColor_7_Background: light-dark(#5d36ff, #d3b6ff);
    --sapIndicationColor_7_BorderColor: light-dark(#5d36ff, #d3b6ff);
    --sapIndicationColor_7_TextColor: light-dark(#fff, #1d232a);
    --sapIndicationColor_7_Hover_Background: light-dark(#481cff, #e2d0ff);
    --sapIndicationColor_7_Active_Background: light-dark(#fff, #213131);
    --sapIndicationColor_7_Active_BorderColor: light-dark(#e2dbff, #2702c2);
    --sapIndicationColor_7_Active_TextColor: light-dark(#5d36ff, #d3b6ff);
    --sapIndicationColor_7_Selected_Background: light-dark(#fff, #213131);
    --sapIndicationColor_7_Selected_BorderColor: light-dark(#e2dbff, #2702c2);
    --sapIndicationColor_7_Selected_TextColor: light-dark(#5d36ff, #d3b6ff);
    --sapIndicationColor_7b: light-dark(#e2dbff, #2702c2);
    --sapIndicationColor_7b_TextColor: light-dark(#5f38ff, #c7baff);
    --sapIndicationColor_7b_Background: light-dark(#e2dbff, #2702c2);
    --sapIndicationColor_7b_BorderColor: light-dark(#e2dbff, #2702c2);
    --sapIndicationColor_7b_Hover_Background: light-dark(#cdc2ff, #2c02db);
    --sapIndicationColor_8: light-dark(#a100c2, #ff8af0);
    --sapIndicationColor_8_Background: light-dark(#a100c2, #ff8af0);
    --sapIndicationColor_8_BorderColor: light-dark(#a100c2, #ff8af0);
    --sapIndicationColor_8_TextColor: light-dark(#fff, #1d232a);
    --sapIndicationColor_8_Hover_Background: light-dark(#8c00a9, #ffa3f3);
    --sapIndicationColor_8_Active_Background: light-dark(#fff, #213131);
    --sapIndicationColor_8_Active_BorderColor: light-dark(#f8d6ff, #4c005b);
    --sapIndicationColor_8_Active_TextColor: light-dark(#a100c2, #ff8af0);
    --sapIndicationColor_8_Selected_Background: light-dark(#fff, #213131);
    --sapIndicationColor_8_Selected_BorderColor: light-dark(#f8d6ff, #4c005b);
    --sapIndicationColor_8_Selected_TextColor: light-dark(#a100c2, #ff8af0);
    --sapIndicationColor_8b: light-dark(#f8d6ff, #4c005b);
    --sapIndicationColor_8b_TextColor: light-dark(#a100c2, #ec89ff);
    --sapIndicationColor_8b_Background: light-dark(#f8d6ff, #4c005b);
    --sapIndicationColor_8b_BorderColor: light-dark(#f8d6ff, #4c005b);
    --sapIndicationColor_8b_Hover_Background: light-dark(#f4bdff, #610075);
    --sapIndicationColor_9: light-dark(#1d2d3e, #f2f2f2);
    --sapIndicationColor_9_Background: light-dark(#1d2d3e, #f2f2f2);
    --sapIndicationColor_9_BorderColor: light-dark(#1d2d3e, #f2f2f2);
    --sapIndicationColor_9_TextColor: light-dark(#fff, #1d232a);
    --sapIndicationColor_9_Hover_Background: light-dark(#15202d, #fff);
    --sapIndicationColor_9_Active_Background: light-dark(#fff, #213131);
    --sapIndicationColor_9_Active_BorderColor: light-dark(#d9d9d9, #3e4b5a);
    --sapIndicationColor_9_Active_TextColor: light-dark(#1d2d3e, #f2f2f2);
    --sapIndicationColor_9_Selected_Background: light-dark(#fff, #213131);
    --sapIndicationColor_9_Selected_BorderColor: light-dark(#d9d9d9, #3e4b5a);
    --sapIndicationColor_9_Selected_TextColor: light-dark(#1d2d3e, #f2f2f2);
    --sapIndicationColor_9b: light-dark(#fff, #1d232a);
    --sapIndicationColor_9b_TextColor: light-dark(#2e2e2e, #f2f2f2);
    --sapIndicationColor_9b_Background: light-dark(#fff, #1d232a);
    --sapIndicationColor_9b_BorderColor: light-dark(#d9d9d9, #3e4b5a);
    --sapIndicationColor_9b_Hover_Background: light-dark(#f2f2f2, #273039);
    --sapIndicationColor_10: light-dark(#45484a, #d8d8d8);
    --sapIndicationColor_10_Background: light-dark(#83888b, #aaa);
    --sapIndicationColor_10_BorderColor: light-dark(#83888b, #aaa);
    --sapIndicationColor_10_TextColor: light-dark(#fff, #1d232a);
    --sapIndicationColor_10_Hover_Background: light-dark(#767b7e, #b7b7b7);
    --sapIndicationColor_10_Active_Background: light-dark(#fff, #213131);
    --sapIndicationColor_10_Active_BorderColor: light-dark(#eaecee, #373737);
    --sapIndicationColor_10_Active_TextColor: light-dark(#45484a, #d8d8d8);
    --sapIndicationColor_10_Selected_Background: light-dark(#fff, #213131);
    --sapIndicationColor_10_Selected_BorderColor: light-dark(#eaecee, #373737);
    --sapIndicationColor_10_Selected_TextColor: light-dark(#45484a, #d8d8d8);
    --sapIndicationColor_10b: light-dark(#eaecee, #373737);
    --sapIndicationColor_10b_TextColor: light-dark(#464646, #d8d8d8);
    --sapIndicationColor_10b_Background: light-dark(#eaecee, #373737);
    --sapIndicationColor_10b_BorderColor: light-dark(#eaecee, #373737);
    --sapIndicationColor_10b_Hover_Background: light-dark(#dcdfe3, #444);
    --sapLegend_WorkingBackground: light-dark(#fff, #1d232a);
    --sapLegend_NonWorkingBackground: light-dark(#ebebeb, #0c0f12);
    --sapLegend_CurrentDateTime: light-dark(#a100c2, #ffafed);
    --sapLegendColor1: light-dark(#c35500, #ffb300);
    --sapLegendColor2: light-dark(#d23a0a, #f5734b);
    --sapLegendColor3: light-dark(#df1278, #feabc8);
    --sapLegendColor4: light-dark(#840606, #db7070);
    --sapLegendColor5: light-dark(#cc00dc, #ff8af0);
    --sapLegendColor6: light-dark(#0057d2, #89d1ff);
    --sapLegendColor7: light-dark(#07838f, #2ce0bf);
    --sapLegendColor8: light-dark(#188918, #97dd40);
    --sapLegendColor9: light-dark(#5b738b, #a9b4be);
    --sapLegendColor10: light-dark(#7800a4, #aa7dd9);
    --sapLegendColor11: light-dark(#a93e00, #f58b00);
    --sapLegendColor12: light-dark(#aa2608, #fbbfac);
    --sapLegendColor13: light-dark(#ba066c, #ffa1a1);
    --sapLegendColor14: light-dark(#8d2a00, #ff9e74);
    --sapLegendColor15: light-dark(#4e247a, #af9cc3);
    --sapLegendColor16: light-dark(#002a86, #aabce3);
    --sapLegendColor17: light-dark(#035663, #dafdf5);
    --sapLegendColor18: light-dark(#1e592f, #d5f1b1);
    --sapLegendColor19: light-dark(#1a4796, #d1efff);
    --sapLegendColor20: light-dark(#470ced, #e2d8ff);
    --sapLegendBackgroundColor1: light-dark(#ffef9f, #382700);
    --sapLegendBackgroundColor2: light-dark(#feeae1, #501605);
    --sapLegendBackgroundColor3: light-dark(#fbf6f8, #510136);
    --sapLegendBackgroundColor4: light-dark(#fbebeb, #411c1c);
    --sapLegendBackgroundColor5: light-dark(#ffe5fe, #28004a);
    --sapLegendBackgroundColor6: light-dark(#d1efff, #00144a);
    --sapLegendBackgroundColor7: light-dark(#c2fcee, #012931);
    --sapLegendBackgroundColor8: light-dark(#f5fae5, #1f2519);
    --sapLegendBackgroundColor9: light-dark(#f5f6f7, #182430);
    --sapLegendBackgroundColor10: light-dark(#fff0fa, #30164b);
    --sapLegendBackgroundColor11: light-dark(#fff8d6, #571400);
    --sapLegendBackgroundColor12: light-dark(#fff6f6, #360c03);
    --sapLegendBackgroundColor13: light-dark(#f7ebef, #3d0000);
    --sapLegendBackgroundColor14: light-dark(#f1ecd5, #421502);
    --sapLegendBackgroundColor15: light-dark(#f0e7f8, #332640);
    --sapLegendBackgroundColor16: light-dark(#ebf8ff, #121d35);
    --sapLegendBackgroundColor17: light-dark(#dafdf5, #013131);
    --sapLegendBackgroundColor18: light-dark(#ebf5cb, #1e3009);
    --sapLegendBackgroundColor19: light-dark(#fafdff, #0a285c);
    --sapLegendBackgroundColor20: light-dark(#eceeff, #1c0c6e);
    --sapChart_Background: light-dark(#fff, #1d232a);
    --sapChart_ContrastTextShadow: var(--_ui5-light-scheme, 0 0 .0625rem rgba(0,0,0,.7)) var(--_ui5-dark-scheme, 0 0 .125rem #fff);
    --sapChart_ContrastShadowColor: #fff;
    --sapChart_ContrastLineColor: light-dark(#fff, #1d232a);
    --sapChart_LineColor_1: light-dark(#e1e6eb, #313941);
    --sapChart_LineColor_2: light-dark(#768da4, #a9b3be);
    --sapChart_LineColor_3: light-dark(#000001, #fff);
    --sapChart_Choropleth_Background: light-dark(#edf0f3, #222f3c);
    --sapChart_ChoroplethRegion_Background: light-dark(#758ca4, #6f89a1);
    --sapChart_ChoroplethRegion_BorderColor: light-dark(#edf0f3, #a2c4e7);
    --sapChart_Data_TextColor: light-dark(#000, #fff);
    --sapChart_Data_ContrastTextColor: light-dark(#fff, #000);
    --sapChart_Data_InteractiveColor: light-dark(#000001, #fff);
    --sapChart_Data_Active_Background: light-dark(#dee2e5, #020303);
    --sapChart_IBCS_Actual: light-dark(#233649, #eaeef2);
    --sapChart_IBCS_Previous: light-dark(#758ca4, #576f86);
    --sapChart_IBCS_Good: light-dark(#287a40, #30914c);
    --sapChart_IBCS_Bad: light-dark(#d00a0a, #f83030);
    --sapChart_OrderedColor_1: light-dark(#168eff, #3278be);
    --sapChart_OrderedColor_2: light-dark(#c87b00, #f2a634);
    --sapChart_OrderedColor_3: light-dark(#75980b, #b4ce35);
    --sapChart_OrderedColor_4: light-dark(#df1278, #fa4f96);
    --sapChart_OrderedColor_5: #8b47d7;
    --sapChart_OrderedColor_6: #049f9a;
    --sapChart_OrderedColor_7: #0070f2;
    --sapChart_OrderedColor_8: light-dark(#cc00dc, #f31ded);
    --sapChart_OrderedColor_9: light-dark(#798c77, #8ea18c);
    --sapChart_OrderedColor_10: light-dark(#da6c6c, #f28585);
    --sapChart_OrderedColor_11: light-dark(#5d36ff, #7858ff);
    --sapChart_OrderedColor_12: #a68a5b;
    --sapChart_Bad: light-dark(#f53232, #f83030);
    --sapChart_Critical: light-dark(#e26300, #dd6100);
    --sapChart_Good: #30914c;
    --sapChart_Neutral: light-dark(#758ca4, #6f89a1);
    --sapChart_Sequence_1_Plus3: light-dark(#8bc7ff, #a2c4e7);
    --sapChart_Sequence_1_Plus3_TextColor: #000;
    --sapChart_Sequence_1_Plus3_TextShadow: 0 0 .125rem #fff;
    --sapChart_Sequence_1_Plus2: light-dark(#62b3ff, #7aabdc);
    --sapChart_Sequence_1_Plus2_TextColor: #000;
    --sapChart_Sequence_1_Plus2_TextShadow: 0 0 .125rem #fff;
    --sapChart_Sequence_1_Plus1: light-dark(#3fa2ff, #5291d1);
    --sapChart_Sequence_1_Plus1_TextColor: #000;
    --sapChart_Sequence_1_Plus1_TextShadow: 0 0 .125rem #fff;
    --sapChart_Sequence_1: light-dark(#168eff, #3278be);
    --sapChart_Sequence_1_TextColor: light-dark(#000, #fff);
    --sapChart_Sequence_1_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #fff) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_1_BorderColor: light-dark(#0074e2, #3278be);
    --sapChart_Sequence_1_Minus1: light-dark(#0074e2, #275e96);
    --sapChart_Sequence_1_Minus1_TextColor: #fff;
    --sapChart_Sequence_1_Minus1_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_1_Minus2: light-dark(#0065c3, #1d456d);
    --sapChart_Sequence_1_Minus2_TextColor: #fff;
    --sapChart_Sequence_1_Minus2_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_1_Minus3: light-dark(#0055a5, #173859);
    --sapChart_Sequence_1_Minus3_TextColor: #fff;
    --sapChart_Sequence_1_Minus3_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_1_Minus4: light-dark(#003b72, #122b45);
    --sapChart_Sequence_1_Minus4_TextColor: #fff;
    --sapChart_Sequence_1_Minus4_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_1_Minus5: light-dark(#00305d, #0d1f31);
    --sapChart_Sequence_1_Minus5_TextColor: #fff;
    --sapChart_Sequence_1_Minus5_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_2_Plus3: light-dark(#efbf72, #fbe5c4);
    --sapChart_Sequence_2_Plus3_TextColor: #000;
    --sapChart_Sequence_2_Plus3_TextShadow: 0 0 .125rem #fff;
    --sapChart_Sequence_2_Plus2: light-dark(#eaaa44, #f8d299);
    --sapChart_Sequence_2_Plus2_TextColor: #000;
    --sapChart_Sequence_2_Plus2_TextShadow: 0 0 .125rem #fff;
    --sapChart_Sequence_2_Plus1: light-dark(#e29419, #f6bf6e);
    --sapChart_Sequence_2_Plus1_TextColor: #000;
    --sapChart_Sequence_2_Plus1_TextShadow: 0 0 .125rem #fff;
    --sapChart_Sequence_2: light-dark(#c87b00, #f2a634);
    --sapChart_Sequence_2_TextColor: #000;
    --sapChart_Sequence_2_TextShadow: 0 0 .125rem #fff;
    --sapChart_Sequence_2_BorderColor: light-dark(#9f6200, #e9920f);
    --sapChart_Sequence_2_Minus1: light-dark(#9f6200, #e9920f);
    --sapChart_Sequence_2_Minus1_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_2_Minus1_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #fff);
    --sapChart_Sequence_2_Minus2: light-dark(#7c4c00, #c37a0c);
    --sapChart_Sequence_2_Minus2_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_2_Minus2_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #fff);
    --sapChart_Sequence_2_Minus3: light-dark(#623c00, #a1650a);
    --sapChart_Sequence_2_Minus3_TextColor: #fff;
    --sapChart_Sequence_2_Minus3_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_2_Minus4: light-dark(#492d00, #855308);
    --sapChart_Sequence_2_Minus4_TextColor: #fff;
    --sapChart_Sequence_2_Minus4_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_2_Minus5: light-dark(#2f1d00, #6d4407);
    --sapChart_Sequence_2_Minus5_TextColor: #fff;
    --sapChart_Sequence_2_Minus5_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_3_Plus3: light-dark(#b9d369, #d9dec3);
    --sapChart_Sequence_3_Plus3_TextColor: #000;
    --sapChart_Sequence_3_Plus3_TextShadow: 0 0 .125rem #fff;
    --sapChart_Sequence_3_Plus2: light-dark(#a6c742, #c3cb9e);
    --sapChart_Sequence_3_Plus2_TextColor: #000;
    --sapChart_Sequence_3_Plus2_TextShadow: 0 0 .125rem #fff;
    --sapChart_Sequence_3_Plus1: light-dark(#8fad33, #b2be78);
    --sapChart_Sequence_3_Plus1_TextColor: #000;
    --sapChart_Sequence_3_Plus1_TextShadow: 0 0 .125rem #fff;
    --sapChart_Sequence_3: light-dark(#75980b, #b4ce35);
    --sapChart_Sequence_3_TextColor: #000;
    --sapChart_Sequence_3_TextShadow: 0 0 .125rem #fff;
    --sapChart_Sequence_3_BorderColor: light-dark(#587208, #67761d);
    --sapChart_Sequence_3_Minus1: light-dark(#587208, #9fb822);
    --sapChart_Sequence_3_Minus1_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_3_Minus1_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #fff);
    --sapChart_Sequence_3_Minus2: light-dark(#3e5106, #8ca611);
    --sapChart_Sequence_3_Minus2_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_3_Minus2_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #fff);
    --sapChart_Sequence_3_Minus3: light-dark(#2c3904, #67761d);
    --sapChart_Sequence_3_Minus3_TextColor: #fff;
    --sapChart_Sequence_3_Minus3_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_3_Minus4: light-dark(#212b03, #4a5515);
    --sapChart_Sequence_3_Minus4_TextColor: #fff;
    --sapChart_Sequence_3_Minus4_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_3_Minus5: light-dark(#161c02, #353d0f);
    --sapChart_Sequence_3_Minus5_TextColor: #fff;
    --sapChart_Sequence_3_Minus5_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_4_Plus3: light-dark(#f473b3, #fec1da);
    --sapChart_Sequence_4_Plus3_TextColor: #000;
    --sapChart_Sequence_4_Plus3_TextShadow: 0 0 .125rem #fff;
    --sapChart_Sequence_4_Plus2: light-dark(#f14d9e, #fc99c2);
    --sapChart_Sequence_4_Plus2_TextColor: #000;
    --sapChart_Sequence_4_Plus2_TextShadow: 0 0 .125rem #fff;
    --sapChart_Sequence_4_Plus1: light-dark(#ee278a, #fb72ab);
    --sapChart_Sequence_4_Plus1_TextColor: #000;
    --sapChart_Sequence_4_Plus1_TextShadow: 0 0 .125rem #fff;
    --sapChart_Sequence_4: light-dark(#df1278, #fa4f96);
    --sapChart_Sequence_4_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_4_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #fff);
    --sapChart_Sequence_4_BorderColor: light-dark(#df1278, #fa4f96);
    --sapChart_Sequence_4_Minus1: light-dark(#b90f64, #f32d80);
    --sapChart_Sequence_4_Minus1_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_4_Minus1_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #fff);
    --sapChart_Sequence_4_Minus2: light-dark(#930c4f, #f20064);
    --sapChart_Sequence_4_Minus2_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_4_Minus2_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #fff);
    --sapChart_Sequence_4_Minus3: light-dark(#770a40, #bf1059);
    --sapChart_Sequence_4_Minus3_TextColor: #fff;
    --sapChart_Sequence_4_Minus3_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_4_Minus4: light-dark(#51072c, #990d47);
    --sapChart_Sequence_4_Minus4_TextColor: #fff;
    --sapChart_Sequence_4_Minus4_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_4_Minus5: light-dark(#3a051f, #6f0934);
    --sapChart_Sequence_4_Minus5_TextColor: #fff;
    --sapChart_Sequence_4_Minus5_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_5_Plus3: light-dark(#d5bcf0, #caacec);
    --sapChart_Sequence_5_Plus3_TextColor: #000;
    --sapChart_Sequence_5_Plus3_TextShadow: 0 0 .125rem #fff;
    --sapChart_Sequence_5_Plus2: light-dark(#b994e0, #b58ae6);
    --sapChart_Sequence_5_Plus2_TextColor: #000;
    --sapChart_Sequence_5_Plus2_TextShadow: 0 0 .125rem #fff;
    --sapChart_Sequence_5_Plus1: light-dark(#a679d8, #a069de);
    --sapChart_Sequence_5_Plus1_TextColor: #000;
    --sapChart_Sequence_5_Plus1_TextShadow: 0 0 .125rem #fff;
    --sapChart_Sequence_5: #8b47d7;
    --sapChart_Sequence_5_TextColor: #fff;
    --sapChart_Sequence_5_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_5_BorderColor: #8b47d7;
    --sapChart_Sequence_5_Minus1: light-dark(#7236b5, #7e2ed7);
    --sapChart_Sequence_5_Minus1_TextColor: #fff;
    --sapChart_Sequence_5_Minus1_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_5_Minus2: light-dark(#5e2c96, #6e1cca);
    --sapChart_Sequence_5_Minus2_TextColor: #fff;
    --sapChart_Sequence_5_Minus2_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_5_Minus3: light-dark(#522682, #591c9c);
    --sapChart_Sequence_5_Minus3_TextColor: #fff;
    --sapChart_Sequence_5_Minus3_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_5_Minus4: light-dark(#46216f, #451679);
    --sapChart_Sequence_5_Minus4_TextColor: #fff;
    --sapChart_Sequence_5_Minus4_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_5_Minus5: light-dark(#341358, #361160);
    --sapChart_Sequence_5_Minus5_TextColor: #fff;
    --sapChart_Sequence_5_Minus5_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_6_Plus3: light-dark(#64ede9, #63e3de);
    --sapChart_Sequence_6_Plus3_TextColor: #000;
    --sapChart_Sequence_6_Plus3_TextShadow: 0 0 .125rem #fff;
    --sapChart_Sequence_6_Plus2: light-dark(#2ee0da, #2dd7d1);
    --sapChart_Sequence_6_Plus2_TextColor: #000;
    --sapChart_Sequence_6_Plus2_TextShadow: 0 0 .125rem #fff;
    --sapChart_Sequence_6_Plus1: light-dark(#05c7c1, #21b5b0);
    --sapChart_Sequence_6_Plus1_TextColor: #000;
    --sapChart_Sequence_6_Plus1_TextShadow: 0 0 .125rem #fff;
    --sapChart_Sequence_6: #049f9a;
    --sapChart_Sequence_6_TextColor: #000;
    --sapChart_Sequence_6_TextShadow: 0 0 .125rem #fff;
    --sapChart_Sequence_6_BorderColor: light-dark(#05c7c1, #049f9a);
    --sapChart_Sequence_6_Minus1: light-dark(#02837f, #018480);
    --sapChart_Sequence_6_Minus1_TextColor: #fff;
    --sapChart_Sequence_6_Minus1_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_6_Minus2: #006663;
    --sapChart_Sequence_6_Minus2_TextColor: #fff;
    --sapChart_Sequence_6_Minus2_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_6_Minus3: #00514f;
    --sapChart_Sequence_6_Minus3_TextColor: #fff;
    --sapChart_Sequence_6_Minus3_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_6_Minus4: #003d3b;
    --sapChart_Sequence_6_Minus4_TextColor: #fff;
    --sapChart_Sequence_6_Minus4_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_6_Minus5: light-dark(#002322, #002e2c);
    --sapChart_Sequence_6_Minus5_TextColor: #fff;
    --sapChart_Sequence_6_Minus5_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_7_Plus3: #68aeff;
    --sapChart_Sequence_7_Plus3_TextColor: #000;
    --sapChart_Sequence_7_Plus3_TextShadow: 0 0 .125rem #fff;
    --sapChart_Sequence_7_Plus2: #4098ff;
    --sapChart_Sequence_7_Plus2_TextColor: #000;
    --sapChart_Sequence_7_Plus2_TextShadow: 0 0 .125rem #fff;
    --sapChart_Sequence_7_Plus1: light-dark(#1c85ff, #1782ff);
    --sapChart_Sequence_7_Plus1_TextColor: #000;
    --sapChart_Sequence_7_Plus1_TextShadow: 0 0 .125rem #fff;
    --sapChart_Sequence_7: #0070f2;
    --sapChart_Sequence_7_TextColor: #fff;
    --sapChart_Sequence_7_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_7_BorderColor: #0070f2;
    --sapChart_Sequence_7_Minus1: light-dark(#0062d3, #0056ba);
    --sapChart_Sequence_7_Minus1_TextColor: #fff;
    --sapChart_Sequence_7_Minus1_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_7_Minus2: light-dark(#0054b5, #00418c);
    --sapChart_Sequence_7_Minus2_TextColor: #fff;
    --sapChart_Sequence_7_Minus2_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_7_Minus3: light-dark(#00418c, #003a7d);
    --sapChart_Sequence_7_Minus3_TextColor: #fff;
    --sapChart_Sequence_7_Minus3_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_7_Minus4: light-dark(#00244f, #00336d);
    --sapChart_Sequence_7_Minus4_TextColor: #fff;
    --sapChart_Sequence_7_Minus4_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_7_Minus5: light-dark(#001b3a, #002959);
    --sapChart_Sequence_7_Minus5_TextColor: #fff;
    --sapChart_Sequence_7_Minus5_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_8_Plus3: light-dark(#f462ff, #fd98fa);
    --sapChart_Sequence_8_Plus3_TextColor: #000;
    --sapChart_Sequence_8_Plus3_TextShadow: 0 0 .125rem #fff;
    --sapChart_Sequence_8_Plus2: light-dark(#f034ff, #f96ef5);
    --sapChart_Sequence_8_Plus2_TextColor: #000;
    --sapChart_Sequence_8_Plus2_TextShadow: 0 0 .125rem #fff;
    --sapChart_Sequence_8_Plus1: light-dark(#ed0bff, #f04dec);
    --sapChart_Sequence_8_Plus1_TextColor: #000;
    --sapChart_Sequence_8_Plus1_TextShadow: 0 0 .125rem #fff;
    --sapChart_Sequence_8: light-dark(#cc00dc, #f31ded);
    --sapChart_Sequence_8_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_8_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #fff);
    --sapChart_Sequence_8_BorderColor: light-dark(#cc00dc, #f31ded);
    --sapChart_Sequence_8_Minus1: light-dark(#a600b3, #d201cc);
    --sapChart_Sequence_8_Minus1_TextColor: #fff;
    --sapChart_Sequence_8_Minus1_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_8_Minus2: light-dark(#80008a, #be00b9);
    --sapChart_Sequence_8_Minus2_TextColor: #fff;
    --sapChart_Sequence_8_Minus2_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_8_Minus3: light-dark(#6d0076, #a1049d);
    --sapChart_Sequence_8_Minus3_TextColor: #fff;
    --sapChart_Sequence_8_Minus3_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_8_Minus4: light-dark(#56005d, #80077c);
    --sapChart_Sequence_8_Minus4_TextColor: #fff;
    --sapChart_Sequence_8_Minus4_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_8_Minus5: light-dark(#350039, #590556);
    --sapChart_Sequence_8_Minus5_TextColor: #fff;
    --sapChart_Sequence_8_Minus5_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_9_Plus3: light-dark(#bdc6bc, #d3dad2);
    --sapChart_Sequence_9_Plus3_TextColor: #000;
    --sapChart_Sequence_9_Plus3_TextShadow: 0 0 .125rem #fff;
    --sapChart_Sequence_9_Plus2: light-dark(#b5bfb4, #c0cabf);
    --sapChart_Sequence_9_Plus2_TextColor: #000;
    --sapChart_Sequence_9_Plus2_TextShadow: 0 0 .125rem #fff;
    --sapChart_Sequence_9_Plus1: light-dark(#97a695, #a4b3a2);
    --sapChart_Sequence_9_Plus1_TextColor: #000;
    --sapChart_Sequence_9_Plus1_TextShadow: 0 0 .125rem #fff;
    --sapChart_Sequence_9: light-dark(#798c77, #8ea18c);
    --sapChart_Sequence_9_TextColor: #000;
    --sapChart_Sequence_9_TextShadow: 0 0 .125rem #fff;
    --sapChart_Sequence_9_BorderColor: light-dark(#798c77, #788f76);
    --sapChart_Sequence_9_Minus1: light-dark(#667664, #788f76);
    --sapChart_Sequence_9_Minus1_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_9_Minus1_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #fff);
    --sapChart_Sequence_9_Minus2: light-dark(#536051, #657963);
    --sapChart_Sequence_9_Minus2_TextColor: #fff;
    --sapChart_Sequence_9_Minus2_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_9_Minus3: light-dark(#404a3f, #546553);
    --sapChart_Sequence_9_Minus3_TextColor: #fff;
    --sapChart_Sequence_9_Minus3_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_9_Minus4: light-dark(#2d342c, #445143);
    --sapChart_Sequence_9_Minus4_TextColor: #fff;
    --sapChart_Sequence_9_Minus4_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_9_Minus5: light-dark(#1e231e, #343e33);
    --sapChart_Sequence_9_Minus5_TextColor: #fff;
    --sapChart_Sequence_9_Minus5_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_10_Plus3: light-dark(#f1c6c6, #fdd6d6);
    --sapChart_Sequence_10_Plus3_TextColor: #000;
    --sapChart_Sequence_10_Plus3_TextShadow: 0 0 .125rem #fff;
    --sapChart_Sequence_10_Plus2: light-dark(#eaadad, #f9b7b7);
    --sapChart_Sequence_10_Plus2_TextColor: #000;
    --sapChart_Sequence_10_Plus2_TextShadow: 0 0 .125rem #fff;
    --sapChart_Sequence_10_Plus1: light-dark(#e28d8d, #f7a4a4);
    --sapChart_Sequence_10_Plus1_TextColor: #000;
    --sapChart_Sequence_10_Plus1_TextShadow: 0 0 .125rem #fff;
    --sapChart_Sequence_10: light-dark(#da6c6c, #f28585);
    --sapChart_Sequence_10_TextColor: #000;
    --sapChart_Sequence_10_TextShadow: 0 0 .125rem #fff;
    --sapChart_Sequence_10_BorderColor: light-dark(#b75757, #e86767);
    --sapChart_Sequence_10_Minus1: light-dark(#b75757, #e86767);
    --sapChart_Sequence_10_Minus1_TextColor: #000;
    --sapChart_Sequence_10_Minus1_TextShadow: 0 0 .125rem #fff;
    --sapChart_Sequence_10_Minus2: light-dark(#9d4343, #d34e4e);
    --sapChart_Sequence_10_Minus2_TextColor: #fff;
    --sapChart_Sequence_10_Minus2_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_10_Minus3: light-dark(#803737, #ac4141);
    --sapChart_Sequence_10_Minus3_TextColor: #fff;
    --sapChart_Sequence_10_Minus3_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_10_Minus4: light-dark(#672c2c, #8b3434);
    --sapChart_Sequence_10_Minus4_TextColor: #fff;
    --sapChart_Sequence_10_Minus4_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_10_Minus5: light-dark(#562424, #752c2c);
    --sapChart_Sequence_10_Minus5_TextColor: #fff;
    --sapChart_Sequence_10_Minus5_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_11_Plus3: light-dark(#c0b0ff, #ddd6fb);
    --sapChart_Sequence_11_Plus3_TextColor: #000;
    --sapChart_Sequence_11_Plus3_TextShadow: 0 0 .125rem #fff;
    --sapChart_Sequence_11_Plus2: light-dark(#9b83ff, #bbacf7);
    --sapChart_Sequence_11_Plus2_TextColor: #000;
    --sapChart_Sequence_11_Plus2_TextShadow: 0 0 .125rem #fff;
    --sapChart_Sequence_11_Plus1: light-dark(#8669ff, #a08bf4);
    --sapChart_Sequence_11_Plus1_TextColor: #000;
    --sapChart_Sequence_11_Plus1_TextShadow: 0 0 .125rem #fff;
    --sapChart_Sequence_11: light-dark(#5d36ff, #7858ff);
    --sapChart_Sequence_11_TextColor: #fff;
    --sapChart_Sequence_11_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_11_BorderColor: light-dark(#5d36ff, #7858ff);
    --sapChart_Sequence_11_Minus1: light-dark(#4b25e7, #633fff);
    --sapChart_Sequence_11_Minus1_TextColor: #fff;
    --sapChart_Sequence_11_Minus1_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_11_Minus2: light-dark(#3a17cd, #4018e8);
    --sapChart_Sequence_11_Minus2_TextColor: #fff;
    --sapChart_Sequence_11_Minus2_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_11_Minus3: light-dark(#2f13a8, #3614c9);
    --sapChart_Sequence_11_Minus3_TextColor: #fff;
    --sapChart_Sequence_11_Minus3_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_11_Minus4: light-dark(#250f83, #2c10a4);
    --sapChart_Sequence_11_Minus4_TextColor: #fff;
    --sapChart_Sequence_11_Minus4_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_11_Minus5: light-dark(#180955, #250d88);
    --sapChart_Sequence_11_Minus5_TextColor: #fff;
    --sapChart_Sequence_11_Minus5_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_12_Plus3: light-dark(#e4ddcf, #dfd5c5);
    --sapChart_Sequence_12_Plus3_TextColor: #000;
    --sapChart_Sequence_12_Plus3_TextShadow: 0 0 .125rem #fff;
    --sapChart_Sequence_12_Plus2: light-dark(#dacebb, #d4c7b1);
    --sapChart_Sequence_12_Plus2_TextColor: #000;
    --sapChart_Sequence_12_Plus2_TextShadow: 0 0 .125rem #fff;
    --sapChart_Sequence_12_Plus1: #c4b293;
    --sapChart_Sequence_12_Plus1_TextColor: #000;
    --sapChart_Sequence_12_Plus1_TextShadow: 0 0 .125rem #fff;
    --sapChart_Sequence_12: #a68a5b;
    --sapChart_Sequence_12_TextColor: #000;
    --sapChart_Sequence_12_TextShadow: 0 0 .125rem #fff;
    --sapChart_Sequence_12_BorderColor: #a68a5b;
    --sapChart_Sequence_12_Minus1: #8c744c;
    --sapChart_Sequence_12_Minus1_TextColor: light-dark(#fff, #000);
    --sapChart_Sequence_12_Minus1_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #fff);
    --sapChart_Sequence_12_Minus2: #786441;
    --sapChart_Sequence_12_Minus2_TextColor: #fff;
    --sapChart_Sequence_12_Minus2_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_12_Minus3: light-dark(#5e4e33, #685638);
    --sapChart_Sequence_12_Minus3_TextColor: #fff;
    --sapChart_Sequence_12_Minus3_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_12_Minus4: light-dark(#433825, #51432c);
    --sapChart_Sequence_12_Minus4_TextColor: #fff;
    --sapChart_Sequence_12_Minus4_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_12_Minus5: light-dark(#30271a, #3d3221);
    --sapChart_Sequence_12_Minus5_TextColor: #fff;
    --sapChart_Sequence_12_Minus5_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_Bad_Plus3: light-dark(#fdcece, #fed8d8);
    --sapChart_Sequence_Bad_Plus3_TextColor: #000;
    --sapChart_Sequence_Bad_Plus3_TextShadow: 0 0 .125rem #fff;
    --sapChart_Sequence_Bad_Plus2: light-dark(#fa9d9d, #f99);
    --sapChart_Sequence_Bad_Plus2_TextColor: #000;
    --sapChart_Sequence_Bad_Plus2_TextShadow: 0 0 .125rem #fff;
    --sapChart_Sequence_Bad_Plus1: light-dark(#f86c6c, #ff5c5c);
    --sapChart_Sequence_Bad_Plus1_TextColor: #000;
    --sapChart_Sequence_Bad_Plus1_TextShadow: 0 0 .125rem #fff;
    --sapChart_Sequence_Bad: light-dark(#f53232, #f83030);
    --sapChart_Sequence_Bad_TextColor: #000;
    --sapChart_Sequence_Bad_TextShadow: 0 0 .125rem #fff;
    --sapChart_Sequence_Bad_BorderColor: light-dark(#f53232, #f83030);
    --sapChart_Sequence_Bad_Minus1: light-dark(#d00a0a, #e01515);
    --sapChart_Sequence_Bad_Minus1_TextColor: #fff;
    --sapChart_Sequence_Bad_Minus1_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_Bad_Minus2: light-dark(#a90808, #b21010);
    --sapChart_Sequence_Bad_Minus2_TextColor: #fff;
    --sapChart_Sequence_Bad_Minus2_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_Bad_Minus3: light-dark(#830606, #830c0c);
    --sapChart_Sequence_Bad_Minus3_TextColor: #fff;
    --sapChart_Sequence_Bad_Minus3_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_Bad_Minus4: light-dark(#570404, #6c0a0a);
    --sapChart_Sequence_Bad_Minus4_TextColor: #fff;
    --sapChart_Sequence_Bad_Minus4_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_Bad_Minus5: light-dark(#320000, #540808);
    --sapChart_Sequence_Bad_Minus5_TextColor: #fff;
    --sapChart_Sequence_Bad_Minus5_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_Critical_Plus3: light-dark(#ffb881, #ffb377);
    --sapChart_Sequence_Critical_Plus3_TextColor: #000;
    --sapChart_Sequence_Critical_Plus3_TextShadow: 0 0 .125rem #fff;
    --sapChart_Sequence_Critical_Plus2: light-dark(#ff933f, #ff8d35);
    --sapChart_Sequence_Critical_Plus2_TextColor: #000;
    --sapChart_Sequence_Critical_Plus2_TextShadow: 0 0 .125rem #fff;
    --sapChart_Sequence_Critical_Plus1: light-dark(#ff760c, #ff7102);
    --sapChart_Sequence_Critical_Plus1_TextColor: #000;
    --sapChart_Sequence_Critical_Plus1_TextShadow: 0 0 .125rem #fff;
    --sapChart_Sequence_Critical: light-dark(#e26300, #dd6100);
    --sapChart_Sequence_Critical_TextColor: #000;
    --sapChart_Sequence_Critical_TextShadow: 0 0 .125rem #fff;
    --sapChart_Sequence_Critical_BorderColor: light-dark(#e26300, #dd6100);
    --sapChart_Sequence_Critical_Minus1: light-dark(#c35600, #be5400);
    --sapChart_Sequence_Critical_Minus1_TextColor: #fff;
    --sapChart_Sequence_Critical_Minus1_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_Critical_Minus2: light-dark(#aa4a00, #aa4b00);
    --sapChart_Sequence_Critical_Minus2_TextColor: #fff;
    --sapChart_Sequence_Critical_Minus2_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_Critical_Minus3: light-dark(#903f00, #913f00);
    --sapChart_Sequence_Critical_Minus3_TextColor: #fff;
    --sapChart_Sequence_Critical_Minus3_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_Critical_Minus4: #6d3000;
    --sapChart_Sequence_Critical_Minus4_TextColor: #fff;
    --sapChart_Sequence_Critical_Minus4_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_Critical_Minus5: light-dark(#492000, #441e00);
    --sapChart_Sequence_Critical_Minus5_TextColor: #fff;
    --sapChart_Sequence_Critical_Minus5_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_Good_Plus3: light-dark(#88d79f, #9bd3ab);
    --sapChart_Sequence_Good_Plus3_TextColor: #000;
    --sapChart_Sequence_Good_Plus3_TextShadow: 0 0 .125rem #fff;
    --sapChart_Sequence_Good_Plus2: light-dark(#56c776, #5eba78);
    --sapChart_Sequence_Good_Plus2_TextColor: #000;
    --sapChart_Sequence_Good_Plus2_TextShadow: 0 0 .125rem #fff;
    --sapChart_Sequence_Good_Plus1: light-dark(#3ab05c, #45a05f);
    --sapChart_Sequence_Good_Plus1_TextColor: #000;
    --sapChart_Sequence_Good_Plus1_TextShadow: 0 0 .125rem #fff;
    --sapChart_Sequence_Good: #30914c;
    --sapChart_Sequence_Good_TextColor: light-dark(#000, #fff);
    --sapChart_Sequence_Good_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #fff) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_Good_BorderColor: #30914c;
    --sapChart_Sequence_Good_Minus1: light-dark(#287a40, #2a7e42);
    --sapChart_Sequence_Good_Minus1_TextColor: #fff;
    --sapChart_Sequence_Good_Minus1_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_Good_Minus2: light-dark(#226736, #236b38);
    --sapChart_Sequence_Good_Minus2_TextColor: #fff;
    --sapChart_Sequence_Good_Minus2_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_Good_Minus3: light-dark(#1c542c, #1d582e);
    --sapChart_Sequence_Good_Minus3_TextColor: #fff;
    --sapChart_Sequence_Good_Minus3_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_Good_Minus4: light-dark(#13391e, #174424);
    --sapChart_Sequence_Good_Minus4_TextColor: #fff;
    --sapChart_Sequence_Good_Minus4_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_Good_Minus5: light-dark(#0a1e10, #10311a);
    --sapChart_Sequence_Good_Minus5_TextColor: #fff;
    --sapChart_Sequence_Good_Minus5_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_Neutral_Plus3: light-dark(#edf0f3, #eaeef2);
    --sapChart_Sequence_Neutral_Plus3_TextColor: #000;
    --sapChart_Sequence_Neutral_Plus3_TextShadow: 0 0 .125rem #fff;
    --sapChart_Sequence_Neutral_Plus2: light-dark(#c2ccd7, #adbcc9);
    --sapChart_Sequence_Neutral_Plus2_TextColor: #000;
    --sapChart_Sequence_Neutral_Plus2_TextShadow: 0 0 .125rem #fff;
    --sapChart_Sequence_Neutral_Plus1: light-dark(#9aabbc, #8ea2b5);
    --sapChart_Sequence_Neutral_Plus1_TextColor: #000;
    --sapChart_Sequence_Neutral_Plus1_TextShadow: 0 0 .125rem #fff;
    --sapChart_Sequence_Neutral: light-dark(#758ca4, #6f89a1);
    --sapChart_Sequence_Neutral_TextColor: #000;
    --sapChart_Sequence_Neutral_TextShadow: 0 0 .125rem #fff;
    --sapChart_Sequence_Neutral_BorderColor: light-dark(#758ca4, #6f89a1);
    --sapChart_Sequence_Neutral_Minus1: light-dark(#5b728b, #576f86);
    --sapChart_Sequence_Neutral_Minus1_TextColor: #fff;
    --sapChart_Sequence_Neutral_Minus1_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_Neutral_Minus2: light-dark(#495e74, #3d566d);
    --sapChart_Sequence_Neutral_Minus2_TextColor: #fff;
    --sapChart_Sequence_Neutral_Minus2_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_Neutral_Minus3: light-dark(#364a5f, #34495c);
    --sapChart_Sequence_Neutral_Minus3_TextColor: #fff;
    --sapChart_Sequence_Neutral_Minus3_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_Neutral_Minus4: light-dark(#233649, #2b3c4c);
    --sapChart_Sequence_Neutral_Minus4_TextColor: #fff;
    --sapChart_Sequence_Neutral_Minus4_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapChart_Sequence_Neutral_Minus5: light-dark(#1a2633, #222f3c);
    --sapChart_Sequence_Neutral_Minus5_TextColor: #fff;
    --sapChart_Sequence_Neutral_Minus5_TextShadow: var(--_ui5-light-scheme, 0 0 .125rem #223548) var(--_ui5-dark-scheme, 0 0 .125rem #000);
    --sapBreakpoint_S_Min: 0;
    --sapBreakpoint_M_Min: 600px;
    --sapBreakpoint_L_Min: 1024px;
    --sapBreakpoint_XL_Min: 1440px;
    --sapSapThemeId: var(--_ui5-light-scheme, sap_horizon) var(--_ui5-dark-scheme, sap_horizon_dark);
    --sapHighlightTextColor: light-dark(#fff, #1d232a);
    --sapButton_Emphasized_FontWeight: bold;
    --sapShell_BackgroundGradient: var(--_ui5-light-scheme, linear-gradient(to bottom, #eff1f2, #eff1f2)) var(--_ui5-dark-scheme, linear-gradient(to bottom, #12171c, #12171c));
    --sapAt: @

}
@media (prefers-color-scheme: dark) {
    :root {
        --_ui5-light-scheme:  ;
        --_ui5-dark-scheme: var(--_ui5-f2d95f8);
        color-scheme: dark}}`